/**
 * ========================================================
 * Description:   Grid component
 * Creation Date: 12/15/15
 * Author: vasil
 * ========================================================
 * Revision History
 * ========================================================
 * Rev     Date        Author           Task      Description
 * ========================================================
 * 1	01/22/16	TB                              Adding custom export functionality
 * 2	02/04/16	Vasil Galinovsky	            Edit form	Added support for popup edit
 * 3	02/04/16	Vasil Galinovsky	            B: Non-admins can't save New entity edit forms	Added entity_access check for adding operation
 * 4	02/04/16	Vasil Galinovsky	            Custom Properties for Grid	Changed highlighting from background-color to font-color
 * 5	02/10/16	Vasil Galinovsky	            Errors cannot be "Closed"
 * 6	02/10/16	Vasil Galinovsky	            Post a Note when comment required for workflow action
 * 7	02/10/16	Vasil Galinovsky	            Fixed image src problem in notes
 * 8	02/12/16	Vasil Galinovsky	            Fixed note template
 * 9    02/12/16    Adam  McDaniel      79900462    Added case for attribute type of "Section" which is the label for directly nested entities
 * 10   02/16/16    Adam  McDaniel      79682245    Changed reference type filters to be simple text fields
 * 11   02/08/16    Sebastian Mansfield             Added functionality to hide columns in screens with < 1000px resolutions
 * 12   02/11/16    Sebastian Mansfield             Wait until modal is loaded to show itself
 * 13   02/12/16    Sebastian Mansfield             Wait until page datalist is loaded to show the modal
 * 14   02/15/16    Sebastian Mansfield             Fixed Conflict with hiding functionality
 * 15   02/16/16    Sebastian Mansfield             Added loading mask
 * 16   02/17/16    Sebastian Mansfield             Used translations for loading masks
 * 17   02/18/16    Sebastian Mansfield             Hide masks in 7 seconds if no server response
 * 18   02/18/16    Sebastian Mansfield             Delay loading mask to allow columns to sort
 * 19   02/23/16    Sebastian Mansfield             Check number of items in nested data grid to adjust its size
 * 20   03/04/16    Sebastian Mansfield             Change the way delete data is sent for nested entities
 * 21   03/08/16    Adam McDaniel       82959271    Removed R_loc and created a folder to put new translations files in for client-side developers
 * 22   03/08/16    Vasil Galinovsky                B: Double add button
 * 23   03/09/16    andrew.gay          82679450    In the "Date" switch case added a converter to change the date string into a date to prevent something else from doing so and converting with time
 * 24   03/11/16    Vasil Galinovsky                B: Double add button
 * 25   03/11/16    Sebastian Mansfield             Fixed duplicate data in data grids when searching or applying a filter
 * 26   03/14/16    Sebastian Mansfield             Fixed bug that only showed 10 rows in a datagrid
 * 27   03/11/16    andrew.gay          82688877    Datetime now acts as a date for the grid search (No time searching)
 * 28   03/14/16    Vasil Galinovsky                B: Note timestamp error
 * 29   03/14/16    Adam McDaniel       83357827    Re-enabled default sorting of entities with fixes for bug that showed only 10 rows.
 * 30   03/17/16    Sebastian Mansfield             Created new function for check all checkbox and fixed functionality.
 * 31   03/18/16    Josue Navarrete     83631545    Fixed bug double Confirmation to on_delete
 * 32   03/25/16    Adam McDaniel       85252548    Added return_app_object_code for edit forms that are launched from a data_list
 * 33   03/25/16    Josue Navarrete     85528185    Added Attribute "note_type" to "comment-footer" div, only display comments-footer when is a comment note_type
 * 34   03/29/16    Josue Navarrete     85525967    Refresh data_grid when export quickbooks
 * 35   03/30/16    Josue Navarrete     85652962    Removed the call to server, 'get_by_code', created state 'not_get_by_code' like a flag, and update_state_form_edit function for create state
 * 36   03/31/16    andrew.gay          84813463    Re-added fix_response_data to "date"
 * 37   04/04/16    Sebastian Mansfield             Added descriptions to datalist
 * 38   04/01/16    Adam McDaniel       86065840    Added for_export tag to init_grid_columns to allow easy use of separate column options if grid is being exported to excel
 * 39   04/05/16    Victor Hernandez    86686287    Added hyperlinks to edit referenced entity column items.
 * 40   04/12/16    Josue Navarrete     87798915    Replaced png profile avatar for fa fa-user-times and nav-bar.js
 * 41   04/12/16    Victor Hernandez    87734022    Replaced Edit, View and Delete buttons for font awesome icons and relocated them for easier use.
 * 42   04/12/16    Victor Hernandez                Removed unused console.logs
 * 43   04/13/16    Victor Hernandez                Moved print button with the rest of the command icons. Made all icons appear only if the user has the proper permissions.
 * 44   04/13/16    Victor Hernandez                Makes sure at least 1 column is always visible, regardless of display size.
 * 45   04/14/16    Josue Navarrete     87734365    Added new button on header to datagrid when props.skip_init=true
 * 46   04/14/16    Josue Navarrete     88285102    Toggle Description to Grids , new Button on top of Datagrid
 * 47   04/14/16    Josue Navarrete     87735390    Detect when error response is session expired and redirect to login
 * 48   04/14/16    Sebastian Mansfield             Deleted scrolls in nested entities grids
 * 49   04/15/16    Josue Navarrete     88355389    skip_init count length of rows of datagrids, fixed styles description buttons
 * 50   04/18/16    Victor Hernandez    88641881    Mass delete button will only show when on or more items are selected.
 * 51   04/18/16    Victor Hernandez    88642000    Changed mass workflow action select box to buttons.
 * 52   04/18/16    Victor Hernandez    88641255    Made nested datagrids ignore the multiselect flag.
 * 53   04/18/16    Victor Hernandez    88642223    Command and select column widths are now responsive.
 * 54   04/19/16    Josue Navarreete                Changes for sprint 20 Xenforma client
 * 55   04/20/16    Victor Hernandez    88007041    Grid will now have a "working" overlay when loading data.
 * 56   04/20/16    Victor Hernandez                Fixed a bug where description open/close events would cause the grid to update its data needlessly.
 * 57   04/20/16    Victor Hernandez    89080420    All mass workflow buttons now float at the bottom of the grid. The grid resizes to accomodate for the buttons.
 * 58   04/22/16    Andrew Gay          88698096    Setting primary key to "_id" instead of querying from attribute.field_path
 * 59   04/25/16    Victor Hernandez                Optimized onSelectionChanged execution speed.
 * 60   05/05/16    Josue Navarrete     87755345    Fixed size of buttons,buttons responsive with mobile and fixed navigation form edit bug.
 * 61   05/06/16    Victor Hernandez                Nested entities that send the image field will now display that image alongside its caption.
 * 62   05/09/16    Victor Hernandez    91413714    Filters can now be set from URL by setting [field_path]=[value] as a GET parameter.
 * 63   05/13/16    Victor Hernandez                Implemented a flag to prevent the updateDimensions method to run simultaneously several times.
 * 64   06/13/16    AMcDaniel           96576253    Changed custom_properties.report_code to custom_properties.reports, which is an array of objects containing {report_code, report_caption}
 * 65   06/14/16    AMcDaniel           96819704    Added ability to receive a redirect_url from response in printReport function
 * 66   06/21/16    AMcDaniel           96819704    Added ability to name this redirect_url file (client-side instead of server-side) from response
 * 67   06/22/16    Victor Hernandez    96595939    Completed multiple report template functionality.
 * 68   06/22/16    Victor Hernadnez    97925159    Multiple report style and caption changes.
 * 69   06/22/16    SMansfield          96775944    Changed functionality to search for primary keys and make them open the edit form
 * 70   06/22/16    SMansfield          96595939    added class to show data lists in popovers
 * 71   06/22/16    Victor Hernandez    97862606    Fixed a bug caused by the server sending strings as highlight rule objects.
 * 72   06/22/16    AMcDaniel           97609452    Added force_refresh parameter to navigation_handler. Consolidated .refresh() calls.
 * 73   06/23/16    Victor Hernandez    97925159    Print button on multiple report popover now hides when no report templates are selected. Print function now sets win.document.title o the current report's report_caption.
 * 74   06/23/16    AMcDaniel           96812150    Added grid_is_on_edit_form property to allow for ref data_lists on edit_form grids.
 * 75   06/23/16    Victor Hernandez    98304215    Added formatting for DateTime field.
 * 76   06/23/16    Victor Hernandez    98304215    Removed seconds from DataTime field format.
 * 77   06/24/16    AMcDaniel           96576253    Added (data).data.html field to report reponse instead of just having it in the (data).data field (so response can have a redirect_url and html)
 * 78   06/27/16    Victor Hernandez    97925159    Implemented printing multiple report templates on a single page.
 * 79   06/27/16    Victor Hernandez    98210663    Refactored all the column hiding/showing logic.
 * 80   06/27/16    Victor Hernandez    98384064    Implemented is_focus prop for the datagrid to auto focus its add button on mount and implemented is_open prop/state.
 * 81   06/27/16    Victor Hernandez    97411990    Implemented tree view functionality
 * 82   06/27/16    AMcDaniel           97216497    Added code to skip pushing to window location for app_objects (also disables close button on data_list)
 * 83   06/28/16    Victor Hernandez    98384064    Removed loading screens when the edit form is in an edit form.
 * 84   06/28/16    AMcDaniel           97216497    Changed captions and descriptions to pull from app_objects first, then entity_attributes. Added option to custom_properties for autoexpand_description
 * 85   06/28/16    Victor Hernandez    98932977    Fixed a bug that caused nested datagrids to take the full height of the screen regardless of the number of rows in it. Also fixed a bug that caused datagrids to fail hiding the status column when filtered by url.
 * 86   06/30/16    Mcasanova                       Adding send_data.sort == undefined validation
 * 87   07/01/16    Victor Hernandez    99349458    Fixed a bug where the description show/hide button for nested datagrids was displayed when grid was hidden.
 * 88   07/01/16    Mcasanova           99525101    Adding anonymous function to set scope of context to load_translations.
 * 89   07/05/16    Victor Hernandez    98991007    Refactored render function for ease of use/reading.
 * 90   07/05/16    JEscudero           99145256    Added a function to delete duplicate data for the contract type treeview.
 * 91   07/06/16    andrew.gay          Bug         retval dates where not passing the conditions, re-added missing code from previous commit.
 * 92   07/05/16    JEscudero           99145256    Fixed hierarchical tree function not passing all the data required.
 * 93   07/06/16    Victor Hernandez    99915243    Grid height calculation fix.
 * 94   07/06/16    JEscudero           98891532    Removed 'rolesmultiple' class in reports dropdown which was causing it to get duplicated.
 * 95   07/07/16    Victor Hernandez    98991007    Initial implementation for calendar_view.
 * 96   07/07/16    JEscudero           100053540   Made treeview show data in alphabetical order.
 * 97   07/08/16    Victor Hernandez    Bug         Fixed a bug that prevented columns from hiding  properly on small mobile screens.
 * 98   07/08/16    Victor Hernandez    Bug         Fixed a bug where selecting tree_view and then navigating to a datalist where such view was unavailable would cause the page to fail render.
 * 99   07/08/16    JEscudero           99914486    Enabled horizontal scrollbar and made the required columns to be fixed (don't move and stay on screen). Also made checkbox column smaller.
 * 100  07/08/16    JEscudero           100073126   Treeview/hierarchy view is now showing the required captions.
 * 100  07/11/16    Mcasanova           98761971    Increse timeout to display the loader.
 * 101  07/11/16    Smansfield                      Fix for horizontal scrollbar in data lists
 * 102  07/12/16    andrew.gay          97886235    Notes will only use the template if it is inside of another edit form (IE has a parent)
 * 103  07/12/16    JEscudero           Bug         Now columns remain fixed after changing dimensions.
 * 104  07/14/16    Victor H            Bug         Fix a bug causing rows to load early.
 * 105  07/14/16    Mcasanova           96812150    Adding conditional to inputs that do not belong to the datalist.
 * 106  07/14/16    JEscudero           98993235    Replaced the delete buttons in the 'controls' column for the Duplicate button.
 * 107  07/14/16    JEscudero           99942365    Now the delete button that appears when checkbox is selected, only appears if the user has 'd' permission
 * 108  07/14/16    Victor Hernandez    101180112   Overriding showAppointmentPopup to have the edit button show the edit form instead.
 * 109  07/14/16    JEscudero           99914486    Fixed a bug that caused the horizontal scrollbar to not appear sometimes when resizing the window.
 * 110  07/14/16    JEscudero           99914486    Fixed a bug that made some columns appear when opening and closing the sidebar.
 * 111  07/15/16    JEscudero           98993235    Fixed a problem that made edit button work like the duplicate button.
 * 112  07/18/16    Sebastian Mansfield             Added coonditions to Map
 * 113  07/18/16    Victor Hernandez    98988838    Added conditions to Calendar.
 * 114  07/19/16    JEscudero           99914486    Now scrollbar shows on mouse hover datagrid. And the columns are now aligned on the contract events.
 * 115  07/19/16    Victor Hernandez    96819755    Downloadable reports now open in the browser instead.
 * 116  07/19/16    Victor Hernandez    Bug         Fixed a bug causing calendar_view to crash on load.
 * 117  07/20/16    JEscudero           99914486    Fixed a bug that cause the scrollbar dissapear in customer contracts.
 * 118  07/20/16    Victor Hernandez    Bug         Fixed a bug causing calendar_view to crash.
 * 119  07/20/16    Victor Hernandez    102091749   Added hyperlinks to access directly variant_reference values.
 * 120  07/20/16    Victor Hernandez    95807097    Added a blank space on assign to box to allow batch clearing assignments.
 * 121  07/20/16    Victor Hernandez    98384064    Fixed a bug causing the scroll position not being restored under certain circumstances.
 * 122  07/21/16    Victor Hernandez    102088504   Fixed a bug causing the workflow buttons to not show under certain circumstances.
 * 123  07/21/16    Victor Hernandez    Bug         Fixed a bug causing nested data_lists to vertically misplace fixed columns.
 * 124  07/25/16    Victor Hernandez    101509696   Multiple field sorting is now supported.
 * 125  07/26/16    Victor Hernandez    101333455   Fixed grid headers misaligning when expanding nested data grids.
 * 126  07/27/16    JEscudero           101525465   Made the viewtypes to only be shown if there is more than one.
 * 127  07/27/16    JEscudero           103182904   Fixed a bug that caused the nested datagrids columns to be unaligned when removing rows.
 * 128  07/27/16    Sebastian Mansfield             Fix for caching in data list
 * 129  07/27/16    Victor Hernandez    Bug         Enabled multiple field sets for maps.
 * 130  07/28/16    JEscudero           99914486    Fixed a bug that caused the horizontal bar not to be shown in some situations (IE11 only).
 * 131  07/28/16    JEscudero           Bug         Made grid update it's dimension when a row is selected.
 * 132  08/01/16    Victor Hernandez    98992528    Data_lists, maps and calendars now keep and share filter conditions.
 * 133  08/02/16    Victor Hernandez    100895945   Fixed a bug causing columns to resize when selecting/deselecting a row.
 * 134  08/02/16    Victor Hernandez    Optimize    Optimized row highlighting logic.
 * 135  08/03/16    AMcDaniel           100948453   Extracted some calendar-related code to a new shared file shared_model_utils.js
 * 136  08/05/16    AMcDaniel           103358588   Added ability to edit in-grid.  Added function launch_edit_form to help separate custom logic from normal grid row-edit logic
 * 137  08/05/16    AMcDaniel           104786045   Added entity_usage field to find_paged send_data
 * 138  08/05/16    AMcDaniel           103358588   Added code to disable editing of columns that are currently clickable (and master column)
 * 139  08/03/16    Sebastian Mansfield             Fix permissions for nested datagrids
 * 140  08/03/16    Sebastian Mansfield             Refactored to work with new devexpress version
 * 141  08/03/16    Sebastian Mansfield             Fix permissions for workflow buttons
 * 142  09/03/16    Sebastian Mansfield             Fixed editing nested entities going through new function
 * 143  09/03/16    Sebastian Mansfield             Fixed deleting dummy row created by dev extreme.
 * 144  08/11/16    Sebastian Mansfield             Made scroillbars appear permanently
 * 145  08/05/16    AMcDaniel           103358588   Fixed problem with excel export being empty the first time
 * 146  08/11/16    AMcDaniel           103417236   Removed fix_sort, and added code server-side to convert the sort conditions from colon-path format to dot-path format.
 * 147  08/15/16    AMcDaniel           105538698   Enabled setting reference values from the data_list
 * 148  08/16/16    AMcDaniel           105538698   Enabled text-edit cursor for editable fields
 * 149  08/17/16    Victor Hernandez    104457614   Changed calendar requests to include null date fields.
 * 150  08/17/16    Victor Hernandez    Bug         Fixed a devExpress bug causing the calendar to crash.
 * 151  08/22/16    AMcDaniel           105538698   Fixed a bug in data_list with selected caption disappearing during save
 * 152  08/24/16    Victor Hernandez    104457614   Calendar now refreshes when edit form closes.
 * 153  08/24/16    Victor Hernandez    Maintenance Tabbed all commit comments on this file to make them more readable.
 * 154  08/24/16    Victor Hernandez    106526745   Fixed a bug causing the checkedAll state to be incorrectly displayed on the grid.
 * 155  08/24/16    Sebastian Mansfield             If screen is phone only show 2 or 3 columns.
 * 156  08/24/16    Victor Hernandez    106526745   Fixed a bug causing the assign_to box to be deleted after using the search box.
 * 157  08/24/16    Victor Hernandez    106526745   Increased search field timeout.
 * 158  08/25/16    Victor Hernandez    107740362   Fixed a bug causing unwanted selections on reload.
 * 159  08/29/16    AMcDaniel           103358588   Fixed a bug causing incorrect scrolling on refresh during grid value updates.
 * 160  08/29/16    Victor Hernandez    106684435   Map view now only displays as many records as the underlying data_list. (default 50)
 * 161  08/30/16    AMcDaniel           106128206   Fixed a bug causing incorrect DateTimes on excel export
 * 162  08/30/16    AMcDaniel           106128206   Fixed a bug with export that was sending a value of skip: 50 sometimes
 * 163  08/30/16    AMcDaniel           106128206   Fixed a bug with export that was ignoring the selectionOnly flag
 * 164  08/30/16    AMcDaniel           106128206   Removed selectionOnly logic from Quickbooks export: always assume selectionOnly
 * 165  08/30/16    Victor Hernandez    108522622   Fixed a bug preventing datagrids from exporting to quickbooks.
 * 166  08/30/16    Victor Hernandez    108567339   Fixed a bug causing date fields to be displayed as current time.
 * 167  08/31/16    Victor Hernandez    100633662   CRUD settings now affect the delete row button display.
 * 168  08/31/16    Victor Hernandez    108804411   Fixed a bug causing referenced datagrids to refresh themselves using the wrong method.
 * 169  09/01/16    Victor Hernandez    106358550   Added regex character escaping to assign to search parameter.
 * 170  09/01/16    AMcDaniel           108531256   Added percent type
 * 171  09/09/16    AMcDaniel           109177071   Replaced makeid logic with general_utils create_guid and create_uid.  Moved get_json_data to general_utils and renamed to get_json_data_using_field_paths
 * 172  09/14/16    AMcDaniel           109177071   Added code to launch edit_forms for individual nested entity entries in array for custom html edit_forms
 * 173  09/27/16    AMcDaniel           112240051   Changed code for grid_properties.rowTemplate for custom xenforma_notes templates to remove the 'this' keyword as it was causing a bug
 * 174  09/28/16    Victor Hernandez    108332481   Hacked dxDatagrid to change the default behaviour of the add button. (previous add button insertion was removed).
 * 175  09/28/16    AMcDaniel           109177071   Changed/Added some styling fixes
 * 176  09/28/16    AMcDaniel           112941853   Remove workflow buttons when user is editing in-grid
 * 177  09/29/16    Victor Hernandez    113073234   Fixed a bug causing numerical fields to be interpreted as strings.
 * 178  09/29/16    Victor Hernandez    113073234   Fixed a bug causing date range serches to crash devExpress.
 * 179  09/29/16    AMcDaniel           112968549   Fixed a bug causing an error to be logged on navigating directly to a supplier data_list page
 * 180  09/29/16    AMcDaniel           113286423   Removed success message from grid editing
 * 196  10/24/16    AMcDaniel           115149055 and 114908962   Refactored to fix errors related to not finding a result in get_grid_object()
 * 197  02/24/17    AMcDaniel           137483455   Changed notes to display the actual time instead of Moment.fromNow
 * 198  02/24/17    AMcDaniel           137483455   Added a DateTimeLocal type for displaying entity Created On and Last Updated On. Fixed bug in time display in last commit.
 * 199  03/15/17    AMcDaniel           137483455   Bug fix for last commit
 * ========================================================
 **/
var DataListComponent = React.createClass({
    statics: {
        note_template_format_date: function () {
            return moment(this.data.data.date_created).format("MM/DD/YYYY h:mm a");
        },
        note_template_format_image: function () {
            if (this.data.data.author && this.data.data.author.image)
                return "<div style='background-image:url("+this.data.data.author.image+");background-repeat:none;background-position:center center;width:35px;height:35px;background-size:cover;' ></div>";
            else
                return  '<i class="fa fa-user" aria-hidden="true" style="margin-top:4px;font-size:27px;color:gray;" ></i>';
        },
        note_template_format_author: function () {
            if (this.data.data.author && this.data.data.author.caption)
                return this.data.data.author.caption;
            return '';
        },
        note_template_format_edit_link: function () {
            if (this.data.data.author && this.data.data.author.entity_id && (user_id == this.data.data.author.entity_id)) {
                return R.edit;
            }
            return '';
        },
        note_template_format_delete_link: function () {
            if (this.data.data.author && this.data.data.author.entity_id && (user_id == this.data.data.author.entity_id)) {
                return R.label_delete;
            }
            return '';
        }
    },
    debugging: false,
    tab: 0,
    calendarTesting:false,
    mapTesting:false,
    debugLog: function (msg, start){
        if (this.debugging){
            if (!start) {
                this.tab--;
            }
            try{
                console.log((start?'-> ':'<- ') + Array(this.tab+1).join('\t') + msg + this.tab);
            } catch(e){console.log((start?'-> ':'<- ') + msg + this.tab);}
            if (start) {
                this.tab++;
            }
        }
    },
    getInitialState: function () {
        this.debugLog('getInitialState', true);
        /*
         if (!this._setState){
         this._setState = this.setState;
         this.setState = function(){
         try{throw new Error('dg_setState')}catch(e){console.log(e)}
         return this._setState.apply(this, arguments);
         };
         }
         if(!this._forceUpdate){
         this._forceUpdate = this.forceUpdate;
         this.forceUpdate = function(){
         try{throw new Error('dg_forceUpdate')}catch(e){console.log(e)}
         return this._forceUpdate.apply(this, arguments);
         };
         }
         */
        var state = this.initialize_data_list();
        if (!state) { //placeholder while waiting for response.
            state = {shouldInitGrid: false};
        }
        var selectedViewsetting = localStorage.getItem('selectedViewsetting');
        if (!(state.app_object &&
            state.app_object.custom_properties.view_modes &&
            state.app_object.custom_properties.view_modes.indexOf(selectedViewsetting) != -1)){
            selectedViewsetting = null;
        }
        if (this.calendarTesting && !this.props.grid_is_on_edit_form && !this.props.skip_init) {
            selectedViewsetting = 'calendar_view';
        }
        if (this.mapTesting && !this.props.grid_is_on_edit_form && !this.props.skip_init) {
            selectedViewsetting = 'map_view';
        }
        switch (selectedViewsetting){
            case null:
                if(state.app_object && state.app_object.custom_properties.view_modes) {
                    localStorage.setItem('selectedViewsetting',state.app_object.custom_properties.view_modes[0]);
                    state.selectedViewsetting = state.app_object.custom_properties.view_modes[0];
                } else{
                    state.selectedViewsetting = 'data_list';
                    localStorage.setItem('selectedViewsetting',state.selectedViewsetting);
                }
                break;
            case "tree_view":
                state.selectedViewsetting = "tree_view";
                break;
            case "calendar_view":
                state.selectedViewsetting = "calendar_view";
                break;
            case "map_view":
                state.selectedViewsetting = "map_view";
                break;
            case "data_list":
                state.selectedViewsetting = "data_list";
                break;
            default:
                state.selectedViewsetting = selectedViewsetting;
        }
        state.grid_id = create_uid();
        state.scrollViewContentElementId = create_uid();
        var context = this;
        if(context.props.record_count) {
            state.get_count = true;
        }
        state.is_open = this.props.is_open;
        this.debugLog('getInitialState', false);
        return state;
    },
    is_readonly: function(){
        return !(this.state.app_object.custom_properties.editable && this.state.entity_access.indexOf('u')!=-1);
    },
    display_loader: function(){
        this.debugLog('display_loader', true);
        var context = this;
        if (!context.props.skip_init && !context.props.grid_is_on_edit_form) {
            context.props.handle_executing(true);
        }
        this.debugLog('display_loader', false);
    },
    set_grid_id: function(new_id){
        this.setState({grid_id:new_id});
    },
    refresh_data_for_rows: function(entity_row_dictionary, entity_inst_id_arr, gridInstance) {
        if(!entity_row_dictionary) {
            return;
        }
        var context = this;
        var request = {
            conditions: {
                _id: {$in: entity_inst_id_arr}
            }
        };
        var success = function (data) {
            context.debugLog('refresh_data_for_rows success', true);
            fix_response_data(data, context.state.entity_attributes.field_paths);
            if(data.entity_instances) {
                data = data.entity_instances;
            }
            if (data.length > 0){
                for(var i = 0; i < data.length; i++) {
                    var newData = data[i];
                    var oldData = entity_row_dictionary[newData._id];
                    if(oldData) { //gut the old row and replace with new data, then refresh.
                        for (var field_name in oldData) {
                            if (!newData.hasOwnProperty(field_name) && (field_name != "_id")) {
                                delete oldData[field_name];
                            }
                        }
                        for (var field_name in newData) {
                            if (newData.hasOwnProperty(field_name)) {
                                oldData[field_name] = newData[field_name];
                            }
                        }
                    }
                }
            }
            context.skip_update = false;
            context.do_refresh_on_complete = false;
            context.skip_update_once = true;
            gridInstance.refresh(); //set new data, but don't make a true DB call
            context.debugLog('refresh_data_for_rows success', true);
        };
        var error = function (error) {
            context.debugLog('refresh_data_for_rows error', true);
            context.setState({error: error.message});
            server_error_action(error);
            context.debugLog('refresh_data_for_rows error', true);
        };
        invoke_method(context.state.app_object.entity, "find_all", request, success, error);
    },
    navigation_handler: function(entity_instance, force_refresh){
        this.debugLog('navigation_handler', true);
        var context = this;
        var gridInstance = this.get_grid_object();
        if(_.isString(entity_instance)) {
            if (entity_instance == "workflow_action") {
                if (this.props.conditions && this.props.conditions.workflow_status &&
                    this.state.app_object && this.state.app_object.workflow_states) {
                    force_refresh = true;
                }
                else {
                    if (gridInstance && this && this.state && this.state.editForm && this.state.editForm.data_row && this.state.selectedViewsetting == 'data_list') {
                        gridInstance.cancelEditData();
                        force_refresh = true;
                    }
                    else {
                        force_refresh = true;
                    }
                }
            }
            else if (entity_instance == "home") {
                force_refresh = true;
            }
            if(force_refresh) {
                if (!context.state.selectedViewsetting){context.state.selectedViewsetting='data_list';}
                switch(context.state.selectedViewsetting){
                    case 'data_list':
                        if(gridInstance) {
                            gridInstance.refresh();
                        }
                        break;
                    case 'tree_view':
                        context.get_treeview_data();
                        break;
                    case 'map_view':
                        context.get_mapview_data();
                        break;
                    case 'calendar_view':
                        if (context.calendar_data_source){
                            context.calendar_data_source.load();
                        }
                        break;
                }
            }
        }
        else{
            if (this.state.editForm.data_row) {
                for (var i = 0; i < this.state.columns.length; i++) {
                    var dataField = this.state.columns[i].dataField;
                    this.state.editForm.data_row[dataField] = entity_instance[dataField];
                }
            }
            if(gridInstance) {
                if (this.state.editForm.data_row) {
                    gridInstance.cancelEditData(); // to refresh grid
                }
                else{
                    gridInstance.refresh();
                }
            }
        }
        if(this.state.duplicate_id){
            this.setState({duplicate_id : undefined});
        }
        this.setState({editForm:undefined});
        this.debugLog('navigation_handler', false);
    },
    initialize_data_list: function () {
        this.debugLog('initialize_data_list', true);
        if (this.props.skip_init) {
            var state_object = {};
            state_object.app_object = this.props.app_object;
            state_object.entity_attributes = this.props.entity_attributes;
            state_object.entity_instances = this.props.entity_instances;
            state_object.shouldInitGrid = true;
            this.debugLog('initialize_data_list', false);
            return state_object;
        }
        var request = {};
        request.entity = "app_object";
        request.method = "get_by_code";
        request.data = {app_object_code: this.props.app_object_code, conditions: this.props.conditions};
        var context = this;
        if (request.data.conditions && Object.keys(request.data.conditions).length !== 0 || localStorage.getItem(context.props.app_object_code) === null || localStorage.getItem(context.props.app_object_code) =="" || localStorage.getItem(context.props.app_object_code) === undefined) {
            do_authenticated_http_call({
                method: "POST",
                url: "/api/entity/invoke_method",
                contentType: "application/json",
                dataType: 'json',
                data: JSON.stringify(request),
                success: function (data) {
                    localStorage.setItem(context.props.app_object_code, JSON.stringify(data.data));
                    var custom_properties = data.data.app_object.custom_properties ? data.data.app_object.custom_properties : {};
                    context.state.app_object = data.data.app_object;
                    context.state.entity_attributes = data.data.entity_attributes;
                    context.state.reports = custom_properties.reports;
                    context.state.entity_access = data.data.entity_access;
                    context.state.entity_instances = [];

                    context.state.shouldInitGrid = true;
                    context.setState(context.state);

                    if(!context.props.grid_is_on_edit_form && !context.props.skip_location_push) {
                        push_href_location(data.data.app_object.name + " - " + (R.client_application_title || "Xenforma"), "/data_list?code=" + data.data.app_object.code);
                    }
                },
                error: function (error) {
                    context.debugLog('initialize_data_list error', true);
                    server_error_action(error);
                    if (error.responseJSON) {
                        /* Validate if session exist */
                        context.setState({error: error.responseJSON.message});
                    }
                    context.debugLog('initialize_data_list error', false);
                }
            });
        }
        else{
            var data = localStorage.getItem(context.props.app_object_code);
            data = JSON.parse(data);
            context.state = {};
            var custom_properties = data.app_object.custom_properties ? data.app_object.custom_properties : {};
            context.state.app_object = data.app_object;
            context.state.entity_attributes = data.entity_attributes;
            context.state.reports = custom_properties.reports;
            context.state.entity_access = data.entity_access;
            context.state.entity_instances = [];
            context.state.shouldInitGrid = true;
            this.debugLog('initialize_data_list', false);
            return(context.state);
        }
        this.debugLog('initialize_data_list', false);
    },
    handle_close: function (event) {
        this.debugLog('handle_close', true);
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        var context = this;
        current_navigation_listener = undefined;
        context.props.navigation_handler("home");
        this.debugLog('handle_close', false);
    },
    update_height: function(){
        this.debugLog('update_height', true);
        var retval = undefined, height_adjustment = 0;
        switch(this.state.selectedViewsetting){
            case 'data_list':
                break;
            case 'tree_view':
                break;
            case 'map_view':
                height_adjustment = -35;
                break;
            case 'calendar_view':
                height_adjustment = -20;
                break;
        }
        if(!this.props.grid_is_on_edit_form){
            var button_container = $('#button-container'),
                description_grid = $(".description_grid");
            if(description_grid.height()==null) {
                retval = $(window).height() - 180 + height_adjustment;
            } else {
                var heightDescription = description_grid.height() + 10;
                if( description_grid.css("display") == "none" ) {
                    heightDescription = 0;
                }
                var heightButtons = button_container.height() + 17;
                if (!button_container.is(':visible')) {
                    heightButtons = 0;
                }
                retval = $(window).height() - 130 - heightDescription - heightButtons + height_adjustment;
            }
        }
        this.debugLog('update_height', false);
        return retval;
    },
    get_grid_object: function(e){
        this.debugLog('get_grid_object', true);
        var react_grid = $('#' + this.state.grid_id);
        var grid = null;
        try {
            switch(this.state.selectedViewsetting){
                case "data_list":
                    grid = react_grid.dxDataGrid('instance');
                    break;
                case "tree_view":
                    grid = react_grid.dxTreeView('instance');
                    break;
                case "calendar_view":
                    grid = react_grid.dxScheduler('instance');
                    break;
                case "map_view":
                    grid = react_grid.dxMap('instance');
                    break;
                default:
                    react_grid.dxDataGrid('instance'); //Defaults to data_list
            }
        } catch(err) {
            grid = null;
        }
        if(grid == null) {
            if(e && e.component) {
                grid = e.component;
            }
            if(grid == null) {
                try {
                    grid = react_grid.dxDataGrid('instance'); //Try to get data_list
                }
                catch (err) {
                    grid = null;
                }
            }
        }

        this.debugLog('get_grid_object', false);
        return grid;
    },
    updateDimensions: function () {
        this.debugLog('updateDimensions', true);
        var context = this,
            grid = this.get_grid_object(),
            isMobile = !!(/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone/i.test(navigator.userAgent)),
            change,
            isChangingOrientation,
            should_hide;
        if (!this.window_width) {
            this.window_width = 1;
        }
        if (!this.window_height) {
            this.window_height = 1;
        }
        change = window.innerWidth/this.window_width -1;
        isChangingOrientation = (change>0?change:(change*-1))>0.01;
        if (isMobile && isChangingOrientation){
            this.window_height = window.innerHeight;
            this.window_width = window.innerWidth;
        }
        if(grid && !context.state.resizing && this.state.selectedViewsetting == 'data_list')    {
            if(grid._options.columns.length < 5 && grid._options.columnAutoWidth == true){
                grid.option('columnAutoWidth', false);
            }
            context.state.resizing = true;
            should_hide = document.documentElement.clientWidth <= 800;
            if (should_hide != context.state.columns_hidden && (!context.state.selectedViewsetting || context.state.selectedViewsetting == "data_list")){
                context.hide_columns(grid, !should_hide);
                grid.columnOption('command:select', 'width', should_hide?25:35);
                grid.columnOption('controls', 'width', should_hide?50:75);
                grid.columnOption('hierarchical_parent', 'width', should_hide?50:300);
                context.setState({columns_hidden: should_hide});
            }
            context.state.resizing = false;
        }
        if (grid && this.state.selectedViewsetting == 'data_list'){
            grid.repaint();
        }
        $("#datalist_cmp").css('visibility', 'visible');
        context.props.handle_executing(false);
        this.debugLog('updateDimensions', false);
    },
    componentDidMount: function () {
        this.debugLog('componentDidMount', true);
        this.display_loader();
        if(this.state.app_object && this.state.app_object.custom_properties.view_modes && this.state.selectedViewsetting == "tree_view"){
            this.get_treeview_data();
        }
        else if(this.state.app_object && this.state.app_object.custom_properties.view_modes && this.state.selectedViewsetting == "map_view"){
            this.get_mapview_data();
        }
        else {
            window.addEventListener("resize", this.updateDimensions);
            window.addEventListener("orientationchange", this.on_orientation_change);
            $(this.popupContentElement).dxScrollView({
                useNative: true,
                scrollByThumb: true
            }).dxScrollView("instance");
            this.popup = $(this.popupElement).dxPopup({
                showTitle: true
            }).dxPopup("instance");
            switch(this.state.selectedViewsetting){
                case 'data_list':
                    if (this.props.skip_init && this.state.shouldInitGrid) { //initialize nested datagrids
                        this.init_grid_columns();
                        this.init_grid();
                    }
                    else{
                        var grid = this.get_grid_object();
                        window.addEventListener("resize", (function(){if(grid){grid.updateDimensions()}}));
                    }
                    break;
                case 'tree_view':
                    break;
                case 'calendar_view':
                    break;
                case 'map_view':
                    break;
            }
        }
        if (!this.calendar){
            this.calendar = this.init_calendar(this.props.skip_init && this.state.shouldInitGrid && !this.props.grid_is_on_edit_form);
        }
        this.debugLog('componentDidMount', false);
    },
    componentWillUnmount: function () {
        this.debugLog('componentWillUnmount', true);
        $(this.popupElement).remove();
        window.removeEventListener("resize", this.updateDimensions);
        window.removeEventListener("orientationchange", this.on_orientation_change);
        this.debugLog('componentWillUnmount', false);
    },
    componentDidUpdate: function () {
        this.debugLog('componentDidUpdate', true);
        var context = this;
        try {
            switch(this.state.selectedViewsetting){
                case 'data_list':
                    var grid = context.get_grid_object();
                    if(grid){grid.updateDimensions()}
                    if (!this.state.last_update){ //check it is not being handled by updateDimensions
                        if(this.state.shouldInitGrid&&(!this.props.skip_init||this.state.app_object)){
                            this.init_grid_columns();
                        }
                        if(this.state.shouldInitGrid&&!this.props.skip_init&&this.state.app_object){
                            this.init_grid(true);
                        }
                    }
                    break;
                case 'tree_view':
                    break;
                case 'calendar_view':
                    break;
                case 'map_view':
                    break;
            }
        } catch (e) {
            //do nothing, an error is expected here as this event is sometimes called before the grid is mounted.
        }
        this.debugLog('componentDidUpdate', false);
    },
    set_custom_note_template: function (grid_properties, custom_properties) {
        this.debugLog('set_custom_note_template', true);
        var context = this;
        grid_properties.showColumnHeaders = false;
        if (context.props.skip_init) {
            grid_properties.scrolling = {showScrollbar: 'none'};
        }
        if (context.state.columns) {
            context.state.columns.splice(0,1);//remove first column, as it is the command column
            grid_properties.rowTemplate =
                '<tbody><tr><td colspan="' + context.state.columns.length + '">' +
                '<div class="comment-body">' +
                '<div className="row" >' +
                '<table class="table" style="width:100%;" >' +
                '<tr><td width="40" valign="center" align="center">' +
                '<a title="">' + '{{html DataListComponent.note_template_format_image}}' + '</a>' +
                '</td><td><div style="margin-left:0px;padding:0px;" class="comment" >' + '<div class="comment-text">' +
                '<div class="comment-header">' +
                '<a title="">' + "${DataListComponent.note_template_format_author}" + '</a><span>' + "${DataListComponent.note_template_format_date}" + '</span>' +
                '</div>' +
                '<i style="margin-right: 5px;" class="fa' + "${data.note_type}" + '"></i>' +
                '<b>' + "${data.subject}" + '</b>' +
                '<div>{{html data.content}}</div>' +
                '</div></div>' +
                '<div style="margin-left:2px; margin-top:5px;" class="comment-footer" note_type="${data.note_type}" >' +
                ((custom_properties.editable) ?
                    ('<a href="javascript:void(0)" onclick="' + "$('#" + context.state.grid_id + "').dxDataGrid('instance').editRow(${rowIndex})" + '" style="color:#d0d0d0;font-size:10px;" >${DataListComponent.note_template_format_edit_link}</a>' + ((!custom_properties.disable_delete) ?
                    '&nbsp;<a href="javascript:void(0)" onclick="' + "$('#" + context.state.grid_id + "').dxDataGrid('instance').removeRow(${rowIndex})" + '" style="color:#d0d0d0;font-size:10px;">${DataListComponent.note_template_format_delete_link}</a>'
                        : ''))
                    : '') +
                '</div>' +
                '' +
                '</td></tr></table>' +
                '</div>' +
                '</div> </td></tr></tbody>';

        }
        context.debugLog('set_custom_note_template', false);
    },
    apply_app_object_sorting: function (grid_sort_obj) {
        this.debugLog('apply_app_object_sorting', true);
        var context = this;
        
        if (grid_sort_obj == null) { //workflow_level sort applies:
            if (context.props.conditions && context.props.conditions.workflow_status && context.state.app_object && context.state.app_object.workflow_states && context.state.app_object.workflow_states[context.props.conditions.workflow_status]) {
                //use workflow sorting first
                var wf_state = context.state.app_object.workflow_states[context.props.conditions.workflow_status];
                if (wf_state.view_options && wf_state.view_options.sort) {
                    grid_sort_obj = wf_state.view_options.sort;
                }
            }
        }
        if (grid_sort_obj == null) { //app_object level sort applies:
            if (context.state.app_object && context.state.app_object.custom_properties && context.state.app_object.custom_properties.sort) {
                grid_sort_obj = context.state.app_object.custom_properties.sort;
            }
        }
        this.debugLog('apply_app_object_sorting', false);
        return grid_sort_obj
    },
    chck_unck_all_columns:function(check){
        this.debugLog('chck_unck_all_columns', true);
        if(!this.checking){
            this.checking = true;
            var grid = this.get_grid_object();
            if(grid) {
                if (check) {
                    var indexes = [];
                for (var i = 0, u = grid.totalCount(); i < u; i++){
                        indexes.push(i);
                    }
                    grid.selectRowsByIndexes(indexes);
                }
                else {
                    grid.clearSelection();
                }
            }
            this.checking = false;
        }
        this.debugLog('chck_unck_all_columns', false);
    },
    insert_add_button : function(context, e){
        context.debugLog('insert_add_button', true);
        var grid = context.get_grid_object(e);
        grid._controllers.editing.addRow = function (_e) { //Hack dxDataGrid to override add button behaviour.
            var app_object = {};
            app_object.code = context.state.app_object.edit_app_object;
            if(context.props.grid_is_on_edit_form) {
                var ref_data = context.props.nested_reference_entity_data;
                context.props.parent_react_entity.setState({
                    nested_reference_entity_data: ref_data,
                    grid_is_on_edit_form: false
                });
            }
            else {
                context.setState({editForm: app_object});
            }
        };
        context.debugLog('insert_add_button', false);
    },
    insert_delete_button : function(context, e){
        context.debugLog('insert_delete_button', true);
        var grid = this.get_grid_object(e);
        var success = function(_e){
            context.debugLog('insert_delete_button success', true);
            Notify(_e.message, 'bottom-right', notify_timeout, 'green', 'fa-check', true);
            grid.refresh();
            grid.clearSelection();
            context.debugLog('insert_delete_button success', false);
        };
        var complete = function (_e){
            context.debugLog('insert_delete_button complete', true);
            grid.clearSelection();
            context.props.handle_executing(false);
            context.debugLog('insert_delete_button complete', false);
        };
        var error = function (err) {
            context.debugLog('insert_delete_button error', true);
            grid.clearSelection();
            grid.refresh();
            context.setState({error: err.message});
            context.debugLog('insert_delete_button error', false);
        };
        $('#' + context.state.grid_id + ' .dx-toolbar-after').each(function () {
            if ($(this).children('div[data-grid-delete-button="true"]').length == 0) {
                var tmpDiv = $("<div data-grid-delete-button='true'/>");
                tmpDiv.dxButton({
                    icon: "fa fa-trash",
                    hint: R.delete_row,
                    height: '35px',
                    onClick: function (_e) {
                        context.debugLog('insert_delete_button onClick', true);
                        //list rows
                        var selected_row_keys = grid.getSelectedRowKeys();
                        if (selected_row_keys.length > 0) {
                            context.confirm(R.label_delete_title, R.message_delete_entity, function (confirmation) {
                                if (confirmation) {
                                    invoke_method(context.state.app_object.entity,"delete_multiple", {id_arr:selected_row_keys}, success, error, complete, context.props.app_object_code);
                                }
                            });
                        }
                        context.debugLog('insert_delete_button onClick', false);
                    }
                });
                $(this).prepend(tmpDiv);
                tmpDiv.hide();//initialize hidden.
            }
        });
        context.debugLog('insert_delete_button', false);
    },
    confirm: function(title, message, callback){
        if (this.props.skip_init || this.props.grid_is_on_edit_form){
            this.props.parent_react_entity.confirm(title, message, callback);
        }
        else{
            display_yes_no_dialogue(title, message, callback);
        }
    },
    build_datasource : function (entity, field_path, add_empty){
        this.debugLog('build_datasource', true);
        var context = this;
        var dataSource = new DevExpress.data.DataSource({
            load: function (loadOptions) {
                context.debugLog('build_datasource load', true);
                var d = new $.Deferred();
                var params = [];
                var request = {};
                request.app_object_code = context.props.app_object_code || context.props.data.app_object_code || context.props.data.app_object.code;
                request.field_path = field_path;
                request.is_new = false;
                request.skip = loadOptions.skip; //A number of records that should be skipped
                request.limit = loadOptions.take; //A number of records that should be taken
                if(loadOptions.searchValue) {
                    params.push(loadOptions.searchExpr);
                    params.push(loadOptions.searchOperation);
                    params.push(loadOptions.searchValue?loadOptions.searchValue.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"):'');
                    request.conditions = make_conditions_from_devextreme_filter(params);
                }
                var success = function (data) {
                    context.debugLog('build_datasource load error', true);
                    if(data.data.length < 11 && dataSource.items().length == 0 ){
                        dataSource.paginate(false);
                    }
                    else{
                        dataSource.paginate(true);
                    }
                    fix_response_data(data, context.state.entity_attributes.field_paths);
                    data = data.data;
                    if (add_empty && data.length > 0){
                        var empty_record = {};
                        for (var field in data[0]){
                            empty_record[field] = null;
                        }
                        data.unshift(empty_record);
                    }
                    d.resolve(data);
                    context.debugLog('build_datasource load error', true);
                };
                var error = function (error) {
                    context.debugLog('build_datasource load error', true);
                    context.setState({error: error.message});
                    server_error_action(error);
                    context.debugLog('build_datasource load error', true);
                };
                invoke_method(entity, "read_with_nested_permissions", request, success, error);
                context.debugLog('build_datasource load', false);
                return d.promise();
            },
            paginate:true,
            byKey: function (key){
                context.debugLog('build_datasource byKey', true);
                var retval;
                if (key && this.items && (typeof this.items == "function")){
                    var items = this.items();
                    retval = find_by_field('entity_id',key, items);
                }
                context.debugLog('build_datasource byKey', false);
                return retval;
            }
        });
        this.debugLog('build_datasource', false);
        return dataSource
    },
    build_assign_box: function(){
        this.debugLog('build_assign_box', true);
        var context = this;
        var grid = context.get_grid_object();
        var success = function(e){
            context.debugLog('build_assign_box success', true);
            Notify(e.message, 'bottom-right', notify_timeout, 'green', 'fa-check', true);
            if(grid) {
                grid.refresh();
                grid.clearSelection();
            }
            context.debugLog('build_assign_box success', false);
        };
        var complete = function (e){
            context.debugLog('build_assign_box complete', true);
            if(grid) {
                grid.clearSelection();
            }
            context.props.handle_executing(false);
            context.debugLog('build_assign_box complete', false);
        };
        var error = function (err) {
            context.debugLog('build_assign_box error', true);
            if(grid) {
                grid.clearSelection();
                grid.refresh();
            }
            context.setState({error: err.message});
            context.debugLog('build_assign_box error', false);
        };
        var on_assigned_user_change = function(data){
            context.debugLog('build_assign_box on_assigned_user_change', true);
            //list rows
            if(grid) {
                var selected_row_keys = grid.getSelectedRowKeys();
                if (selected_row_keys.length > 0) {
                    var request = {};
                    request.id_arr = selected_row_keys;
                request.upsert_data={};
                request.upsert_data.assigned_to_user = data?data.entity_id:null;
                invoke_method(context.state.app_object.entity,"upsert_multiple", request, success, error, complete);
                }
            }
            context.debugLog('build_assign_box on_assigned_user_change', false);
        };
        if (!context.users_datasource){
            context.users_datasource = context.build_datasource("user", "assigned_to_user", true);
        }
        this.debugLog('build_assign_box', false);
        return <div id="assign-box" style={{display:"block", float:"left"}}>
            <EditorDevExtremeLookup
                dataSource={context.users_datasource}
                displayExpr="caption"
                valueExpr="entity_id"
                value=''
                placeholder={R.assign_to? R.assign_to+"...":"Assign to..."}
                onChange={on_assigned_user_change}
                readOnly={false}
            />
        </div>;
    },
    insert_assign_box: function(context, e){
        this.debugLog('insert_assign_box', true);
        $('#' + context.state.grid_id + ' .dx-toolbar-after').each(function () {
            if ($(this).children('#assign-box').length == 0 && $('#assign-box').length != 0) {
                var tmpDiv = $('#assign-box');
                $(tmpDiv).prependTo(this);
                tmpDiv.hide();//initialize hidden.
            }
        });
        this.debugLog('insert_assign_box', false);
    },
    handle_workflow_change : function(){
        this.debugLog('handle_workflow_change', true);
        var context = this;
        var grid = context.get_grid_object();
        var entity_method = 'change_multiple_entity_workflow_states';
        context.display_loader();
        var error = function(event){
            context.debugLog('handle_workflow_change error', true);
            context.setState({error: event.message});
            context.debugLog('handle_workflow_change error', false);
        };
        var success = function(event){
            context.debugLog('handle_workflow_change success', true);
            Notify(event.message, 'bottom-right', notify_timeout, 'green', 'fa-check', true);
            context.debugLog('handle_workflow_change success', false);
        };
        var complete = function (event){
            context.debugLog('handle_workflow_change complete', true);
            if (context.props.handle_executing) {context.props.handle_executing(false);}
            //reset checked rows
            if(grid) {
                grid.clearSelection();
                grid.refresh();
            }
            context.debugLog('handle_workflow_change complete', false);
        };
        if (context.state.workflow_change_data){
            invoke_method(context.state.app_object.entity,
                entity_method,
                context.state.workflow_change_data,
                success,
                error,
                complete,
                context.props.app_object_code
            );
        }
        this.debugLog('handle_workflow_change', true);
    },
    insert_report_button : function(context, reports){
        this.debugLog('insert_report_button', true);
        if(reports) {
            context.setState({report_options:reports});
        }
        $('#' + context.state.grid_id + ' .dx-toolbar-after').each(function () {
            if ($(this).children('div[data-report-print-button="true"]').length == 0) {
                var tmpDiv = $("<div id='report-button' data-report-print-button='true'/>");
                tmpDiv.dxButton({
                    icon: "fa fa-print",
                    hint: R.report_print_button_hint,
                    height: '35px',
                    onClick: function () {
                        context.debugLog('insert_report_button onClick', true);
                        if(reports.length > 1){
                            context.chooseReport("report-button");
                        }
                        else{
                            context.printReportRecursive(reports);
                        }
                        context.debugLog('insert_report_button onClick', false);
                    }
                });
                $(this).prepend(tmpDiv);
            }
        });
        this.debugLog('insert_report_button', false);
    },
    printReportRecursive: function(reports, key){
        this.debugLog('printReportRecursive', true);
        if (reports.length){
            var context = this,
                report = [],
                win,
                grid = context.get_grid_object();
            if(grid) {
                var selectedRows = grid.getSelectedRowKeys();
                if (key || selectedRows.length > 0) {
                    win = window.open('', '', '');
                }
            for (var i = 0, j = reports.length; i < j; i++){
                report.push(reports[i].report_code?reports[i].report_code:reports[i].value);
                }
            }
            context.printReport(report, win, !key, key);
        }
        this.debugLog('printReportRecursive', false);
    },
    printSelectedReports: function (key){
        this.debugLog('printSelectedReports', true);
        if (this.selected_reports.length){
            this.printReportRecursive(this.selected_reports, this.print_key);
        }
        this.debugLog('printSelectedReports', false);
    },
    chooseReport:function(target, key){
        this.debugLog('chooseReport', true);
        this.print_key = key;
        var context = this;
        context.open_popover("choose_report_popover", function(){
            context.debugLog('chooseReport open_popover', true);
            try{
                $('#selectchoose_report_popover').each(function(){
                    var element = $(this);
                    element.multiselect({
                        enableHTML:true,
                        buttonWidth: '100%',
                        buttonTitle: function(options, select) {
                            context.selected_reports = options;
                            var printButton = $('#button_choose_report_popover');
                            if (options.length > 0){
                                printButton.show();
                            } else {
                                printButton.hide();
                            }
                        }
                    });
                    var button_box = $('<div/>', {style:"padding:5px"}),
                        save_button_var = $('<button/>', {
                                type:'button',
                                style:'margin:5px; float:right; margin-left:5px: margin-top:5px;margin-bottom:10px',
                                class:'btn btn-success shiny workflow_button_margin',
                                id:'button_choose_report_popover',
                                text: R.print?R.print:"Print",
                                click: context.printSelectedReports
                            }),
                        cancel_button_var = $('<button/>', {
                                type:'button',
                                style:'margin:5px; float:right; margin-left:5px: margin-top:5px;margin-bottom:10px',
                                class:'btn shiny btn-default',
                                id:'button_cancel_assigned_to_user',
                                text: R.label_cancel,
                                click: function(){context.state.popover.hide()}
                            });
                    cancel_button_var.appendTo(button_box);
                    save_button_var.appendTo(button_box);
                    $(button_box).appendTo($(element).parents()[1]);
                    save_button_var.hide();
                });
            }
            catch(error){}
            context.debugLog('chooseReport open_popover', false);
        },target);
        context.debugLog('chooseReport', false);
    },
    printReport: function (report_code, win, isList, id, callback) {
        this.debugLog('printReport', true);
        var context = this;
        var error = function (err) {
            context.debugLog('printReport error', true);
            win.close();
            context.setState({error: err.message});
            if (callback) {
                callback(err);
            }
            context.debugLog('printReport error', false);
        };
        var success = function (e) {
            context.debugLog('printReport success', true);
            if(e.data) {
                function redirect(data){
                    var filename = data.download_name || data.redirect_url;
                    var xhr = new XMLHttpRequest();
                    xhr.responseType = 'blob';
                    xhr.onload = function () {
                        context.debugLog('printReport success onload', true);
                        var a = document.createElement('a');
                        a.href = win.URL.createObjectURL(xhr.response); // xhr.response is a blob
                        a.download = filename; // Set the file name.
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                        context.debugLog('printReport success onload', false);
                    };
                    xhr.open('GET', e.data.redirect_url);
                    xhr.send();
                }
                if (e.data.downloads && e.data.downloads.length){
                    win.location.assign(e.data.downloads[0].redirect_url);
                    for(var i = 1, u = e.data.downloads.length; i<u; i++){
                        window.open(e.data.downloads[i].redirect_url);
                    }
                }
                if (e.data.redirect_url) {
                    redirect(e.data);
                }
                if(e.data.html) {
                    win.document.write(e.data.html);
                    $(win).load(function () {
                        context.debugLog('printReport success load', true);
                        try {
                            win.document.title = find_by_field("report_code", report_code, context.state.app_object.custom_properties.reports).report_caption;
                        } catch (e) {}
                        win.print();
                        win.close();
                        context.debugLog('printReport success load', false);
                    });
                    win.document.close();
                }
            }
            if (win){
                win.focus();
            }
            if (callback) {
                callback();
            }
            context.debugLog('printReport success', false);
        };
        var send_data = {};
        var grid = context.get_grid_object();
        if(grid) {
            var selected_rows = grid.getSelectedRowKeys().map(
                function (currentValue, index, arr) {
                    return currentValue;
                }
            );
        }
        var conditions;
        if (selected_rows && (selected_rows.length > 0)) {
            conditions = {"_id": {"$in": selected_rows}};
        }
        else {
            if (isList){
                if (callback) {
                    callback();
                }
                return;
            }
        }
        if (!conditions) {
            conditions = context.state.export_grid_conditions;
        }
        if ("string" == typeof report_code){
            send_data.app_object_code = report_code;
        }
        else{
            send_data.report_app_object_codes = report_code;
        }
        if (isList) {
            send_data.report_type = 'list';
            send_data.conditions = conditions;
        }
        else {
            send_data._id = id;
        }
        invoke_method("app_object", "get_by_code", send_data, success, error);
        context.debugLog('printReport', false);
    },
    insert_export_button: function(custom_export, e){
        var context = this;
        this.debugLog('insert_export_button', true);
        $('#' + context.state.grid_id + ' .dx-datagrid-export-button').each(function () {
            if (typeof $(this).data("custom-export") == "undefined") {
                var grid = context.get_grid_object(e);
                $(this).data("custom-export", '');
                grid._controllers.export.selectionOnly(true);
                grid._$element.find('.dx-datagrid').data('options', { //edited dx-viz.min.js to make the _renderExportMenu read this from the datagrid, include the new option in the menu and override the excel export if there is an onClick event defined.
                    icon: "doc",
                    text: custom_export.caption,
                    internalFields: {childrenKeys: []},
                    onClick: function(ev){
                        ev.jQueryEvent.preventDefault();
                        var send_data = {};
                        send_data.format = custom_export.format;
                        send_data.data = grid.getSelectedRowKeys();
                        send_data.gridConditions = context.state.export_grid_conditions;
                        var error = function (err) {
                            context.debugLog('insert_export_button onClick onClick error', true);
                            context.setState({error: err.message});
                            context.debugLog('insert_export_button onClick onClick error', false);
                        };
                        var success = function (_e) {
                            context.debugLog('insert_export_button onClick onClick success', true);
                            //create file and show as download
                            var blob = new Blob([_e.filecontents], {type: "text/plain"});
                            saveAs(blob, _e.filename);
                            context.debugLog('insert_export_button onClick onClick success', false);
                        };
                        invoke_method(context.state.entity_attributes.entity, "custom_export", send_data, success, error);
                    }
                });
            }
        });
        this.debugLog('insert_export_button', false);
    },
    fix_calendar_overlap: function(by_resource){
        var item,
            items,
            resource,
            next_resource,
            next_resource_name,
            base_resource_name,
            resource_keys = Object.keys(by_resource),
            same_resource_count,
            is_overlap = false;
        for (var i=0;i<resource_keys.length;i++){
            resource = resource_keys[i];
            same_resource_count = 0;
            base_resource_name = resource;
            resource_keys.forEach(function(currentValue){
                if (resource.indexOf(currentValue) == 0){
                    if (!base_resource_name || base_resource_name.length > currentValue.length){
                        base_resource_name = currentValue;
                    }
                }
            });
            resource_keys.forEach(function(currentValue){
                if (currentValue.indexOf(base_resource_name) == 0){
                    same_resource_count++;
                }
            });
            next_resource_name = base_resource_name + same_resource_count;
            next_resource = by_resource[next_resource_name];
            items = by_resource[resource];
            for(var j=0; j<items.length-1;j++){
                if (items[j].endDate>items[j+1].startDate){
                    is_overlap = true;
                    item = items[j+1];
                    //update the item.
                    if(Array.isArray(item.resources)){
                        if(item.resources[item.resources.indexOf(resource)] == -1){
                            item.resources.push(next_resource_name);
                        }
                        else {
                            item.resources[item.resources.indexOf(resource)] = next_resource_name;
                        }
                    }
                    else{
                        item.resources = [next_resource_name];
                    }
                    //update the resource array.
                    if (!next_resource){
                        by_resource[next_resource_name] = [item];
                        resource_keys.push(next_resource_name);
                        next_resource = [item];
                    }
                    else{
                        by_resource[next_resource_name].push(item);
                    }
                    items.splice(j+1,1);
                }
            }
        }
        return is_overlap;
    },
    load_calendar_dataSource:function(){
        this.debugLog('load_calendar_dataSource', true);
        var fields = this.state.app_object.custom_properties.calendar_fields;
        if (!fields){
            fields = [];
            fields[0] = {
                end_datetime_field:'expiration_date',
                start_datetime_field:'contract_date',
                recurrence_field:'trans_schedule',
                resources_field:'workflow_status'
            }
        }
        else {
            for (var i = 0, u = fields.length; i < u; i++){
                fields[i].resources_field = fields[i].resources_field||'workflow_status'
            }
        }
        var send_data = {
                conditions: {},
                last_id: undefined
            },
            context = this,
            error_func = function (error) {
                context.debugLog('load_calendar_dataSource error_func', true);
                if (error.responseJSON) {
                    context.setState({error: error.responseJSON.message});
                } else if(error.message){
                    context.setState({error:error.message});
                } else if (error) {
                    context.setState({error:error});
                }
                context.debugLog('load_calendar_dataSource error_func', false);
            },
            data_source = new DevExpress.data.DataSource({
                key: "_id", //this.state.primaryKey,
                load: function (load_options) {
                    context.debugLog('load_calendar_dataSource load', true);
                    context.state.loading = true;
                    var d = new $.Deferred();
                    var success_func = function (data) {
                        context.debugLog('load_calendar_dataSource load success_func', true);
                        fix_response_data(data,  context.state.entity_attributes.field_paths);
                        var retval = convert_results_to_calendar_fields(fields, data.entity_instances, context.state.entity_attributes, true);
                        //Separate elements by resource
                        var by_resource = {}, resources, resource, j, v;
                        for(i = 0, u = retval.length; i<u; i++){
                            resources = retval[i].resources;
                            for(j = 0, v = resources.length; j<v;j++){
                                resource = resources[j];
                                if (!by_resource[resource]){
                                    by_resource[resource] = [retval[i]];
                                } else {
                                    by_resource[resource].push(retval[i]);
                                }
                            }
                        }
                        //organize each set of elements by start date
                        var resource_keys = Object.keys(by_resource);
                        for (i=0,u=resource_keys.length; i<u;i++){
                            by_resource[resource_keys[i]] = order_by_field('startDate', by_resource[resource_keys[i]]);
                        }
                        //check for overlap. If there's overlap check next id. If next id does not exist create it and add the item.
                        var is_overlap = true;
                        while(is_overlap){
                            is_overlap = context.fix_calendar_overlap(by_resource);
                        }
                        d.resolve(retval);
                        context.debugLog('load_calendar_dataSource load success_func', false);
                    };
                    if (!load_options.skip) { //null or 0 --happens when filter is changed.
                        if (load_options.skip === 0) {
                            send_data.last_id = undefined;
                            send_data.skip = undefined;
                        }
                        var conditions, scheduler = load_options.dxScheduler;
                        if (scheduler && scheduler.endDate && scheduler.startDate){
                            var f1, f2;
                            if (fields.length > 1){
                                conditions = {"$or":[]};
                                for (var i = 0, u = fields.length; i < u; i++){
                                    f1 = fields[i].start_datetime_field||fields[i].end_datetime_field;
                                    f2 = fields[i].end_datetime_field||fields[i].start_datetime_field;
                                    conditions["$or"][i] = {"$and":[{"$or":[{},{}]},{"$or":[{},{}]}]};
                                    conditions["$or"][i]["$and"][0]["$or"][0][f1] = {"$lte":scheduler.endDate};
                                    conditions["$or"][i]["$and"][0]["$or"][1][f1] = {"$eq":null};
                                    conditions["$or"][i]["$and"][1]["$or"][0][f2] = {"$gte":scheduler.startDate};
                                    conditions["$or"][i]["$and"][1]["$or"][1][f2] = {"$eq":null};
                                }
                            }
                            else{
                                f1 = fields[0].start_datetime_field||fields[0].end_datetime_field;
                                f2 = fields[0].end_datetime_field||fields[0].start_datetime_field;
                                conditions = {"$and":[{"$or":[{},{}]},{"$or":[{},{}]}]};
                                conditions["$and"][0]["$or"][0][f1] = {"$lte":scheduler.endDate};
                                conditions["$and"][0]["$or"][1][f1] = {"$eq":null};
                                conditions["$and"][1]["$or"][0][f2] = {"$gte":scheduler.startDate};
                                conditions["$and"][1]["$or"][1][f2] = {"$eq":null};
                            }
                        }
                        if(context.state.export_grid_conditions && Object.keys(context.state.export_grid_conditions).length){
                            if (conditions){
                                send_data.conditions = {"$and":[
                                    context.state.export_grid_conditions,
                                    conditions
                                ]}
                            }
                            else{
                                send_data.conditions = context.state.export_grid_conditions;
                            }
                        }
                        else{
                            send_data.conditions = conditions;
                        }
                        if (load_options.sort && Array.isArray(load_options.sort)) {
                            send_data.sort = make_sorting_conditions_from_devextreme_sort(load_options.sort);
                        }
                        else {
                            send_data.sort = undefined;
                        }
                    }
                    else {
                        if (load_options.sort && Array.isArray(load_options.sort)) {
                            send_data.skip = load_options.skip;
                            send_data.last_id = undefined; //not used in sorted paging
                        }
                    }
                    send_data.app_object_code = context.props.app_object_code;
                    send_data.sort = context.apply_app_object_sorting(send_data.sort);
                    var char_count = 0;
                    if(send_data.sort){
                        char_count = ( JSON.stringify(send_data.sort).match(/:/g) || []).length;
                    }
                    if (char_count > 1){
                        send_data.sort = JSON.stringify(send_data.sort).replace(/[:]/,'.');
                        send_data.sort = jQuery.parseJSON(  send_data.sort);
                    }
                    if (send_data.sort) {
                        if (!send_data.skip) {
                            send_data.skip = 0;
                        }
                        send_data.last_id = undefined; //not used in sorted paging
                    }
                    console.log('sent-search-request-calendar');
                    var complete_func = function(e){
                        context.debugLog('load_calendar_dataSource load complete_func', true);
                        context.state.loading = false;
                        context.props.handle_executing(false);
                        context.last_load = 'calendar_view';
                        context.debugLog('load_calendar_dataSource load complete_func', false);
                    };
                    if(!context.isDeleting){
                        invoke_method(context.state.entity_attributes.entity, "get_calendar_data", send_data, success_func, error_func, complete_func);
                    }
                    context.debugLog('load_calendar_dataSource load', false);
                    return d.promise();
                },
                remove: function (key) {
                    context.debugLog('load_calendar_dataSource remove', true);
                    context.debugLog('load_calendar_dataSource remove', false);
                },
                insert: function (values) {
                    context.debugLog('load_calendar_dataSource insert', true);
                    context.debugLog('load_calendar_dataSource insert', false);
                },
                update: function (key, values) {
                    context.debugLog('load_calendar_dataSource update', true);
                    context.debugLog('load_calendar_dataSource update', false);
                }
            });
        this.debugLog('load_calendar_dataSource', false);
        return data_source;
    },
    set_filters: function(grid, filter){
        var columns = this.state.columns,
            key = Object.keys(filter)[0],
            filter_array,
            value;
        if ('$or' == key){
            key = Object.keys(filter['$or'][0])[0];
            var panel = grid.option('searchPanel');
            panel.text = filter['$or'][0][key]['$regex'];
        }
        else {
            filter_array = Array.isArray(filter[key])?filter[key]:[filter];
            for (var i = 0, u = filter_array.length;i<u;i++){
                key = Object.keys(filter_array[i])[0];
                for (var j=0,v=columns.length;j<v;j++){
                    if (columns[j].name == key){
                        value = filter_array[i][key]['$regex'] || filter_array[i][key]['$eq'] || filter_array[i][key]['$not']['$regex'] || filter_array[i][key]['$ne'];
                        columns[j].filterValue = filter_array[i][key]['$regex'];
                    }
                }
            }
            grid.option('columns', columns);
        }
    },
    load_dataSource:function(force_ref_load, send_data){
        this.debugLog('load_dataSource', true);
        if (!send_data){
            send_data = {
                conditions: {},
                last_id: undefined
            };
        }
        var data_source,
            context = this,
            error_func = function (error) {
                context.debugLog('load_dataSource error_func', true);
                if (error.responseJSON) {
                    context.setState({error: error.responseJSON.message});
                } else if(error.message){
                    context.setState({error:error.message});
                } else if (error) {
                    context.setState({error:error});
                }
                context.debugLog('load_dataSource error_func', false);
            };
        if ((this.props.skip_init || this.props.grid_is_on_edit_form) && (!force_ref_load)) {
            data_source = fix_response_data(this.state.entity_instances, this.state.entity_attributes.field_paths);
            if(this.props.skip_init) {
                //Until server starts sending correct flag for these grids.
                this.state.app_object.custom_properties.grid_multi_select = false;
                $("#" + context.state.grid_id + '  .dx-datagrid-addrow-button').hide();
            }
        }
        else{
            data_source = new DevExpress.data.DataSource({
                key: "_id", //this.state.primaryKey,
                isLoading: function(){
                    return this._isLoading;
                },
                load: function (load_options) {
                    context.debugLog('load_dataSource load', true);
                    var grid = context.get_grid_object();
                    if(!grid) {
                        return;
                    }
                    columnCount = grid.columnCount();
                    var columnCount, i, currentColumnOptions;
                    for (i = 0; i < columnCount; i++){
                        currentColumnOptions = grid.columnOption(i);
                        if (currentColumnOptions.selectedFilterOperation === "between") {
                            context.skipUpdateDimensions = true;
                        }
                    }
                    if(context.skip_update || context.skip_update_once) {
                        context.skip_update_once = false; //used because this happens async with no callback to tell when it is done, and we want to set skip_update to false after this has finished, so we set false before, and use skip_update_once flag.
                        return context.state.last_entity_instances; //use last results if skip_update
                    }
                    context.state.loading = true;
                    this._isLoading = true;
                    var d = new $.Deferred(),
                        conditions,
                        checkedState = $("#" + context.state.grid_id + ' *[aria-label="Select all"]>div').attr('aria-checked');
                    var success_func = function (data) {
                        context.debugLog('load_dataSource load success_func', true);
                        var do_reset_inst_array = ((send_data.last_id == null) && !send_data.skip);
                        fix_response_data(data, context.state.entity_attributes.field_paths);
                        var arr = data.entity_instances, el;
                        for (var i = 0, u = arr.length; i<u;i++){
                            el = arr[i];
                            el.row_highlight_color = context.get_row_highlighting(el);
                        }
                        var first_find = (context.state.was_checked_all == null);
                        context.state.was_checked_all = !(!context.state.checked_all);
                        context.state.checked_all = (first_find) ? false : (!($('div',"#" + context.state.grid_id).find('[aria-label="Select all"] [aria-checked]').first().attr('aria-checked') == "false"));

                        var skip_set_local_instances = (context.state.checked_all && (context.state.checked_all != context.state.was_checked_all)); //Runs load event when Select All checkbox is clicked to true, but we don't want this to interfere with our results tracking
                        if (first_find || !skip_set_local_instances) {
                            if (do_reset_inst_array || !context.state.last_entity_instances || !context.state.last_entity_instances.length) {
                            context.state.last_entity_instances = data.entity_instances;
                        }
                        else {
                            context.state.last_entity_instances = add_to_list(context.state.last_entity_instances, data.entity_instances);
                        }
                        context.state.last_entity_instances_dictionary = convert_to_dictionary_by_field_names(context.state.last_entity_instances, {key: "_id"});
                        }
                        d.resolve(data.entity_instances);
                        context.debugLog('load_dataSource load success_func', false);
                    };
                    if(context.state.last_entity_instances && context.state.last_entity_instances.length && context.state.last_entity_instances[context.state.last_entity_instances.length-1]) {
                        send_data.last_id = context.state.last_entity_instances[context.state.last_entity_instances.length-1]._id;
                    }
                    else {
                            send_data.last_id = undefined;
                        }
                    if (!load_options.skip || devextreme_sorting_conditions_changed(send_data.last_dx_sort, load_options.sort)) { //load_options.skip is null or 0 when filter is changed.
                        send_data.last_id = undefined; //reset when conditions change (also: not used in sorted paging)
                        conditions = context.props.conditions || {};
                        if (load_options.filter && Array.isArray(load_options.filter)) {
                            send_data.conditions = make_conditions_from_devextreme_filter(load_options.filter) || {};
                            for (var field_path in conditions) { //these filters override custom filters
                                send_data.conditions[field_path] = conditions[field_path];
                            }
                        }
                        else {
                            send_data.conditions = conditions;
                        }
                        if (load_options.sort && Array.isArray(load_options.sort)) {
                            send_data.sort = make_sorting_conditions_from_devextreme_sort(load_options.sort);
                            send_data.last_dx_sort = shallow_copy(load_options.sort);
                        }
                        else {
                            send_data.sort = undefined;
                            send_data.last_dx_sort = undefined;
                        }
                    }
                    if(context.state.export_grid_conditions && Object.keys(context.state.export_grid_conditions).length && context.last_load != 'data_list'){
                        context.set_filters(grid, context.state.export_grid_conditions);
                        if (Object.keys(send_data.conditions).length == 0){
                            conditions = context.state.export_grid_conditions;
                        }
                        else{
                            conditions = {$and:[context.state.export_grid_conditions, send_data.conditions]};
                            context.state.export_grid_conditions = send_data.conditions;
                        }
                    }
                    else{
                        context.state.export_grid_conditions = send_data.conditions;
                        conditions = send_data.conditions;
                    }
                    send_data.conditions = conditions;
                    send_data.app_object_code = context.props.app_object_code;
                    send_data.skip = load_options.skip;
                    send_data.sort = context.apply_app_object_sorting(send_data.sort);
                    if (send_data.sort) {
                        send_data.last_id = undefined; //not used in sorted paging
                    }
                    else {
                        send_data.skip = undefined; //we use sorting by _id for this, with no skip (uses >)
                    }
                    console.log('sent-search-request');
                    var dxGrid_context = this;
                    var complete_func = function(e){
                        context.debugLog('load_dataSource load complete_func', true);
                        context.state.loading = false;
                        dxGrid_context._isLoading = false;
                        context.last_load = 'data_list';
                        if (!context.state.selectedViewsetting || context.state.selectedViewsetting == "data_list"){
                            if (checkedState == "true"){
                                context.chck_unck_all_columns(true);
                            }
                            else if (checkedState == "false"){
                                context.chck_unck_all_columns(false);
                            }
                        }
                        var selectedKeys = grid.getSelectedRowKeys(),
                            deselectKeys = [];
                        for (var x in selectedKeys){
                            if (grid.getRowIndexByKey(selectedKeys[x])==-1){
                                deselectKeys.push(selectedKeys[x]);
                            }
                        }
                        if (deselectKeys.length){
                            grid.deselectRows(deselectKeys);
                        }
                        if(load_options.filter){
                            $('.dx-datagrid .dx-datagrid-search-panel').dxTextBox('instance').focus();
                        }
                        if (!context.skipUpdateDimensions){
                            context.updateDimensions();
                        }
                        else{
                            context.skipUpdateDimensions = false;
                        }
                        var is_checked_all = (!($('div',"#" + context.state.grid_id).find('[aria-label="Select all"] [aria-checked]').first().attr('aria-checked') == "false"));
                        if(!is_checked_all) {
                            context.state.checked_all = false;  //only used to flag this back to false because of weird behavior in Select All when a grid filter is applied
                        }
                        context.debugLog('load_dataSource load complete_func', false);
                    };
                    if(context.state.app_object && context.state.app_object.entity_usage) {
                        send_data.entity_usage = context.state.app_object.entity_usage;
                    }

                    if(!context.isDeleting){
                        invoke_method(context.state.entity_attributes.entity, "find_paged", send_data, success_func, error_func, complete_func);
                    }
                    context.debugLog('load_dataSource load', false);
                    return d.promise();
                },
                remove: function (key) {
                    context.debugLog('load_dataSource remove', true);
                    context.debugLog('load_dataSource remove', false);
                },
                insert: function (values) {
                    context.debugLog('load_dataSource insert', true);
                    context.debugLog('load_dataSource insert', false);
                },
                update: function (key, values) {
                    context.debugLog('load_dataSource update', true);
                }
            });
        }

        this.debugLog('load_dataSource', false);
        return data_source;
    },
    init_grid: function (force_ref_load) {
        this.debugLog('init_grid', true);
        var grid_properties = {};
        var context = this;
        grid_properties.onOptionChanged = function (e) { //move assignbox out of the grid before it searches to prevent devExpress from eliminating it as it redraws itself.
            context.debugLog('optionChanged', true);
            var is_checked_all = (!($('div',"#" + context.state.grid_id).find('[aria-label="Select all"] [aria-checked]').first().attr('aria-checked') == "false"));
            if(!is_checked_all) {
                context.state.checked_all = false;  //only used to flag this back to false
            }
            if (e.fullName == 'searchPanel.text'){
                $('#assign-box').prependTo('#' + context.state.grid_id).hide();
            }
            context.debugLog('optionChanged', false);
        };
        var error_func = function (error) {
            context.debugLog('init_grid error_func', true);
            if (error.responseJSON) {
                context.setState({error: error.responseJSON.message});
            } else if(error.message){
                context.setState({error:error.message});
            } else if (error) {
                context.setState({error:error});
            }
            context.debugLog('init_grid error_func', false);
        };
        //load datasource
        var send_data = {
            conditions: {},
            last_id: undefined
        };
        this.grid_data_source = this.load_dataSource(force_ref_load, send_data);
        if (!(this.props.skip_init || this.props.grid_is_on_edit_form) || force_ref_load) {
            grid_properties.paging = {enabled:true, pageSize: context.state.app_object.page_size || 50}; //infinite scroll requires pageSize.
        }
        var custom_properties = this.state.app_object.custom_properties ? this.state.app_object.custom_properties : {};
        var multiSelect = custom_properties.grid_multi_select == undefined ? false : custom_properties.grid_multi_select;
        grid_properties.dataSource = this.grid_data_source;
        grid_properties.onRowPrepared = function (e){
            if (e.rowType == 'data' && e.data.row_highlight_color){
                $(e.rowElement).css('color', e.data.row_highlight_color);
            }
        };
        grid_properties.onCellPrepared = function (e) {
            var column = e.column;
            if(column.allow_column_edit) {
                var cellElement = e.cellElement;
                cellElement.addClass('dx-edit'); //Adds a text cursor to indicate the cell is editable
            }
        };
        //set size
        if (!this.props.skip_init && !this.props.grid_is_on_edit_form) {
            grid_properties.height = function () {
                context.debugLog('init_grid grid_properties.height', true);
                var grid = $(".description_grid");
                if(grid.height()==null) {
                    context.debugLog('init_grid grid_properties.height', false);
                    return $(window).height() - 180 ;
                }
                var heightDescription = grid.height();
                if( grid.css("display") == "none" ) {
                    heightDescription = 0;
                }
                context.debugLog('init_grid grid_properties.height', false);
                return $(window).height() - 195 - heightDescription;
            };
        }
        grid_properties.columnFixing = {enabled : true};
        grid_properties.loadPanel = {
            enabled : true
        };
        grid_properties.columns = this.state.columns;
        grid_properties.columnAutoWidth = false;
        //Activates horizontal scroll bar if true.
        if(document.documentElement.clientWidth >= 800){
            grid_properties.columns > 5 ? grid_properties.columnAutoWidth = true : grid_properties.columnAutoWidth = false;
        }
        grid_properties.allowColumnResizing = true;
        grid_properties.allowColumnReordering = true;
        grid_properties.showRowLines = true;
        grid_properties.wordWrapEnabled = true;
        grid_properties.rowAlternationEnabled = true;
        grid_properties.headerFilter = {visible: true};
        grid_properties.searchPanel = {visible: !this.props.skip_init && !this.props.grid_is_on_edit_form};
        grid_properties.filterRow = {visible: !this.props.skip_init && !this.props.grid_is_on_edit_form};
        if(this.props.app_object&&this.props.app_object.entity=="xenforma_note"){
            grid_properties.headerFilter = {visible: true , text : "Comment"};
            grid_properties.paging = {enabled: false}; //infinite scroll requires pageSize.
            grid_properties.filterRow = {visible: true};
            grid_properties.onEditorPrepared = function(e) {
                try{//just in case the Editor is not actually ready.
                    var selectBox = e.editorElement.dxSelectBox('instance');
                    if (selectBox) {
                        selectBox.option('searchEnabled', false);
                    }
                } catch(er){}
            }
        }
        else {
            grid_properties.onEditorPrepared = function(e) {
                if (e.editorName=="dxSelectBox"){
                    e.editorElement.dxSelectBox('instance').option('searchEnabled', false);
                }
                if (e.updateValueTimeout){
                    e.updateValueTimeout = 1500;
                }
                if((e.parentType == "dataRow") && (e.dataField)) {
                    if (e.editorElement[e.editorName] && (typeof e.editorElement[e.editorName] == "function")) {
                        var local_temp_dx_element = e.editorElement[e.editorName]('instance');
                        if (local_temp_dx_element) {
                            local_temp_dx_element.on('disposing', function (local_event) {
                                if(e.row && e.row.key) {
                                    context.change_workflow_button_count(false, e.dataField + e.row.key);
                                }
                                context.run_selection_buttons_display_logic();
                            });
                        }
                    }
                }
            }
        }
        grid_properties.export = {
            enabled: !this.props.skip_init,
            fileName: this.state.app_object.name,
            allowExportSelectedData: multiSelect
        };
        grid_properties.stateSorting = {enabled: true, type: 'localStorage', storageKey: 'xenforma'};
        grid_properties.scrolling = {mode: "infinite", preloadEnabled:false, showScrollbar: "always"};
        grid_properties.selection = {
            mode: multiSelect ? "multiple" : "none",
            showCheckBoxesMode: multiSelect ? "always" : "none"
        };
        grid_properties.onEditorPreparing = function (info) {
            if (info.parentType == 'filterRow') {
                if (info.format == 'shortTime') {
                    info.editorOptions.format = "time";
                } else if (info.format == 'shortdateshorttime') {
                    info.editorOptions.format = "datetime";
                }
            }
        };
        if (custom_properties.custom_template == "note" && this.props && this.props.parent_entity_field_attribute) {
            this.set_custom_note_template(grid_properties, custom_properties);
        }
        var nested_popup_func;
        grid_properties.onContentReady = function (e) {
            context.debugLog('init_grid onContentReady', true);
                //add report button
                if (custom_properties.reports) {
                    context.insert_report_button(context, custom_properties.reports);
                }
                //add export button
                if (grid_properties.export.enabled && custom_properties.custom_export) {
                    context.insert_export_button(custom_properties.custom_export, e);
                }
            if(e.component.columnOption('command:edit', 'visible')) {
                e.component.columnOption('command:edit', 'visible', false);
            }
            context.debugLog('init_grid onContentReady', false);
        };
        if (this.state.app_object.edit_app_object) {
            if (this.props.skip_init) {
                if (!custom_properties.edit_in_grid) {
                    nested_popup_func = nested_entity_row_popup_function.bind(context, context);
                    grid_properties.onEditingStart = function (event) {
                        context.debugLog('init_grid onEditingStart', true);
                        event.cancel = true;
                        var data_row = event.data;
                        if (data_row._id) {
                            data_row = $.extend(true, {}, data_row);
                            context.debugLog('init_grid onEditingStart', false);
                            return nested_popup_func(data_row);
                        }
                        context.debugLog('init_grid onEditingStart', false);
                    };
                }
            }
            else {
                grid_properties.onEditingStart = function (event) {
                    context.debugLog('init_grid onEditingStart', true);
                    if(context.state && context.state.entity_access && context.state.entity_access.indexOf('u')!=-1) {
                        //allow normal logic flow, but disable workflow buttons
                        if(event.column && event.key) {
                            context.change_workflow_button_count(true, event.column.dataField + event.key);
                        }
                        context.run_selection_buttons_display_logic();
                    }
                    else {
                        event.cancel = true;
                    }
                    if(context.props.grid_is_on_edit_form) {
                        event.cancel = true;
                        var data_row = event.data;
                        if (data_row._id) {
                            var app_object = {};
                            app_object.code = context.state.app_object.edit_app_object;
                            app_object.data_row = data_row;
                            app_object._id = data_row._id;
                            var ref_data = context.props.nested_reference_entity_data;
                            context.props.parent_react_entity.setState({
                                nested_reference_entity_data: ref_data,
                                reference_entity_id: data_row._id,
                                grid_is_on_edit_form: true
                            });
                        }
                    }
                    context.debugLog('init_grid onEditingStart', false);
                };
                grid_properties.onCellClick = function(event) {
                    if(event && event.key && event.column && event.column.allow_column_edit && event.column.allowEditing && context.state && context.state.entity_access && context.state.entity_access.indexOf('u')!=-1) {
                        context.change_workflow_button_count(true, event.column.dataField + event.key);
                        context.run_selection_buttons_display_logic();
                    }
                };
                var temp_grid_properties = $.extend(true, {}, grid_properties);
                context.state.entity_instances = context.state.entity_instances || [];
                temp_grid_properties.dataSource = context.state.entity_instances;
                temp_grid_properties.visible = false;
                temp_grid_properties.export.enabled = false;
                temp_grid_properties.columns = this.init_grid_columns(true);
                temp_grid_properties.onSelectionChanged = function(e) {
                    e.component.exportToExcel(true);
                    context.props.handle_executing(false);
                };
                $("#" + "hidden_export_" + this.state.grid_id).dxDataGrid(temp_grid_properties);
                var export_success_func = function (data) {
                    context.debugLog('init_grid export_success_func', true);
                    fix_response_data(data, context.state.entity_attributes.field_paths);
                    context.state.entity_instances.length = 0; //delete all of these
                    context.state.entity_instances.push.apply(context.state.entity_instances, data.entity_instances);
                    var temp_grid = $("#" + "hidden_export_" + context.state.grid_id).dxDataGrid("instance");
                    temp_grid.refresh();
                    temp_grid.selectAll();//Fires the SelectionChanged event when finished, which forces export.
                    context.debugLog('init_grid export_success_func', false);
                };
                var export_error_func = function (error) {
                    context.debugLog('init_grid export_error_func', true);
                    if (error.responseJSON) {
                        context.setState({error: error.responseJSON.message});
                    }
                    context.props.handle_executing(false);
                    context.debugLog('init_grid export_error_func', false);
                };
                grid_properties.onExporting = function (event) {
                    context.debugLog('init_grid onExporting', true);
                    event.cancel = true;
                    context.display_loader();
                    var local_send_data = $.extend({}, send_data || {});
                    delete local_send_data.last_id;
                    delete local_send_data.skip;
                    var selected_rows;
                    if (context.get_grid_object(event)._views.headerPanel._exportController._selectionOnly) {
                        selected_rows = event.component.getSelectedRowKeys().map(
                            function (currentValue) {
                                return currentValue;
                            }
                        );
                    }
                    var conditions;
                    if (selected_rows && (selected_rows.length > 0)) {
                        conditions = {"_id": {"$in": selected_rows}};
                    }
                    if (!conditions) {
                        conditions = context.state.export_grid_conditions;
                    }
                    local_send_data.app_object_code = context.props.app_object_code;
                    local_send_data.conditions = conditions;
                    local_send_data.sort = context.apply_app_object_sorting(local_send_data.sort);
                    invoke_method(context.state.entity_attributes.entity, "find_all", local_send_data, export_success_func, export_error_func);
                    context.debugLog('init_grid onExporting', false);
                };
            }
        }
        for (var property in custom_properties) {
            grid_properties[property] = custom_properties[property];
        }
        grid_properties.editing = {
            mode: "cell",
            allowAdding: custom_properties.editable && context.state.entity_access && context.state.entity_access.indexOf('c') != -1,
            allowEditing: false,
            allowUpdating: true,
            allowDeleting: false //((!custom_properties.disable_delete) && (custom_properties.editable)),
        };
        if (!this.props.skip_init) {
            var success_func_maker = function(e) {
                return function (data) {
                    context.debugLog('init_grid success', true);
                    if (context.state.entity_attributes && context.state.entity_attributes.entity == 'translation') {
                        load_translations(false, function () {
                            context.forceUpdate();
                        });
                    }
                    var grid = context.get_grid_object(e);
                    if (context.isDeleting || (context.skip_update && context.do_refresh_on_complete)) {
                        if (context.do_refresh_on_complete) {
                            /*var entity_row_dictionary = context.do_refresh_on_complete.entity_row_dictionary;
                            var entity_inst_id_arr = context.do_refresh_on_complete.entity_inst_id_arr;
                            context.do_refresh_on_complete = false;
                            context.refresh_data_for_rows(entity_row_dictionary, entity_inst_id_arr, grid);
                            */
                            context.do_refresh_on_complete = false;
                        }
                        else {
                            grid.refresh();
                        }
                    }
                    else if (!context.skip_update) {
                        grid.repaint();
                    }
                    context.debugLog('init_grid success', false);
                };
            };
            var complete = function () {
                context.debugLog('init_grid complete', true);
                if (context.isDeleting && (context.props.skip_init || context.props.grid_is_on_edit_form) && context.props.parent_react_entity){
                    context.props.parent_react_entity.set_confirming(false);
                }
                context.isDeleting = false;
                context.skip_update = false;
                setTimeout(function(){
                    context.props.handle_executing(false);
                }, 0);
                context.debugLog('init_grid complete', false);
            };
            grid_properties.onRowUpdating = function (e) {
                context.debugLog('init_grid onRowUpdating', true);
                var entity = context.state.entity_attributes.entity;
                var method_name = "upsert";
                var from_in_grid_editing = (!e.key._id && e.key);
                var _id = e.key._id || e.key;
                var update_data = e.newData;
                update_data._id = _id;
                var selected_rows = null;
                var do_busy_indicator = false;
                if(from_in_grid_editing) {
                    for(var field_name in e.newData) {
                        if(e.newData.hasOwnProperty(field_name)) {
                            e.oldData[field_name] = e.newData[field_name];
                        }
                    }
                    e.component.cancelEditData();
                    if(context.force_edit_refresh) { //overrides default editing behavior (for entity references which behave oddly after editing)
                        context.force_edit_refresh = false;
                        context.skip_update = true;
                    }
                    else {
                        context.skip_update = true;
                        context.do_refresh_on_complete = false; //don't need for only a single row
                    }
                    selected_rows = e.component.getSelectedRowKeys().map(
                        function (currentValue, index, arr) {
                            return currentValue;
                        }
                    );
                    if (selected_rows && (selected_rows.length > 1) && (selected_rows.indexOf(_id) != -1)) {
                        //apply this same data change to each row
                        method_name = "upsert_multiple";
                        context.do_refresh_on_complete = {entity_inst_id_arr: selected_rows, entity_row_dictionary: context.state.last_entity_instances_dictionary};
                        delete update_data._id;
                        update_data = {upsert_data: update_data};
                        update_data.id_arr = selected_rows;
                        if(selected_rows.length >= 2) { //do this to keep requests from conflicting
                            do_busy_indicator = true;
                        }
                    }
                    else {
                        context.do_refresh_on_complete = {entity_inst_id_arr: [_id], entity_row_dictionary: context.state.last_entity_instances_dictionary};
                    }
                }
                var error = function (err) {
                    context.debugLog('init_grid onRowUpdating error', true);
                    context.setState({error: err.message});
                    e.component.cancelEditData();
                    if (context.do_refresh_on_complete) {
                        context.do_refresh_on_complete = false;
                        context.skip_update = false;
                        e.component.refresh();
                    }
                    context.debugLog('init_grid onRowUpdating error', false);
                };
                var local_success_function = success_func_maker(e);
                var local_complete = function() {
                    context.skip_update = false;
                    context.skip_update_once = true;
                    e.component.refresh(); //set new data, but don't make a true DB call - We have to force run this refresh now to prevent dx from running it, but there is still a bug: //TODO: Fix paging after this refresh skip
                    if(do_busy_indicator) {
                        context.props.handle_executing(false);
                    }
                };
                if(do_busy_indicator) {
                    context.props.handle_executing(true);
                }

                invoke_method(entity, method_name, update_data, (do_busy_indicator)? function(data) {Notify(data.message, 'bottom-right', notify_timeout, 'green', 'fa-check', true); return local_success_function(data);} : local_success_function, error, local_complete);
                if(selected_rows && context.state.last_entity_instances_dictionary) { //update displayed values on grid for selected rows
                    var newData = update_data.upsert_data;
                    var entity_instances = context.state.last_entity_instances_dictionary; //dictionary by _id
                    for(var i = 0; i < selected_rows.length; i++) {
                        var oldData = entity_instances[selected_rows[i]];
                        if(oldData) {
                            for (var field_name in newData) {
                                if (newData.hasOwnProperty(field_name)) {
                                    oldData[field_name] = newData[field_name];
                                }
                            }
                        }
                    }
                    e.component.repaint();
                }
                context.debugLog('init_grid onRowUpdating', false);
                return true;
            };
            grid_properties.onRowInserting = function (e) {
                context.debugLog('init_grid onRowInserting', true);
                var document = e.data;
                var entity = context.state.entity_attributes.entity;
                var error = function (err) {
                    context.setState({error: err.message});
                    e.component.cancelEditData();
                };
                invoke_method(entity, "upsert", document, success_func_maker(e), error, complete);
                context.debugLog('init_grid onRowInserting', false);
            };
            grid_properties.onRowRemoving = function (e) {
                context.debugLog('init_grid onRowRemoving', true);
                var _id = e.data._id;
                var entity = context.state.entity_attributes.entity;
                var error = function (err) {
                    context.setState({error: err.message});
                };
                context.display_loader();
                context.isDeleting = true;
                invoke_method(entity, "delete", {_id: _id}, success_func_maker(e), error, complete);
                context.debugLog('init_grid onRowRemoving', false);
            };
            grid_properties.onContentReady = function(e){
                context.debugLog('init_grid onContentReady', true);
                if((!custom_properties.disable_create) && (custom_properties.editable)){
                    grid_properties.editing.allowAdding = true;
                }
                if (context.state.entity_access && context.state.entity_access.indexOf('c')==-1) {
                    grid_properties.editing.allowAdding = false;
                }
                if(grid_properties.editing.allowAdding){
                    context.insert_add_button(context, e);
                }
                if(custom_properties.editable && !custom_properties.disable_delete && context.state.entity_access.indexOf('d')!=-1) {
                    context.insert_delete_button(context, e);
                }
                if(custom_properties.assign_to && custom_properties.editable && context.state.entity_access.indexOf('u')!=-1){
                    context.insert_assign_box(context, e);
                }
                if(e.component.columnOption('command:edit', 'visible')) {
                    e.component.columnOption('command:edit', 'visible', false);
                }
                context.debugLog('init_grid onContentReady', false);
            };
            grid_properties.onSelectionChanged = function(e){
                context.state.workflow_button_hide_count = 0;
                return context.run_selection_buttons_display_logic(e);
            };
            grid_properties.height = this.update_height;
        }
        else {
            //nested entities
            var on_change = function (e) {
                context.debugLog('init_grid on_change', true);
                if(e.data && e.data.__KEY__){
                    e.cancel = true;
                }
                else{
                    if (context.props.on_change) {
                        context.props.on_change(context.state.entity_instances);
                    }
                }
                context.debugLog('init_grid on_change', false);
            };
            grid_properties.onRowRemoving = function (e) {
                context.debugLog('init_grid on_delete', true);
                var retval = context.props.delete_nested_entity(context.props.parent_entity_field_attribute, context.props.parent_entity_array, e.key._id);
                if (context.isDeleting && (context.props.skip_init || context.props.grid_is_on_edit_form) && context.props.parent_react_entity){
                    context.props.parent_react_entity.set_confirming(false);
                }
                context.debugLog('init_grid on_delete', false);
                return retval;
            };
            grid_properties.onRowUpdating = on_change;
            grid_properties.onRowInserting = on_change;
            if (nested_popup_func) {
                grid_properties.onContentReady = function (e) {
                    context.debugLog('init_grid onContentReady', true);
                    $("#" + context.state.grid_id + '  .dx-datagrid-addrow-button').click(function () {
                        var data_row = {};
                        return nested_popup_func(data_row, true);
                    });
                    //allow reader users or read only forms too add notes
                    if(!e.component.option('editing.allowAdding') && (!context.props.read_only || context.state.app_object.entity == "xenforma_note" )) {
                        e.component.option('editing.allowAdding', true);
                }
                    if(e.component.columnOption('command:edit', 'visible')) {
                        e.component.columnOption('command:edit', 'visible', false);
                    }
                    $('.fachange_history').removeClass('fachange_history').addClass( "fa fa-pencil-square-o" );
                    $('.facomment').removeClass('fachange_history').addClass( "fa fa-comment-o" );
                    $('.comment-footer[note_type!="comment"]').css("display" , "none");
                    $('.faworkflow').removeClass('fachange_history').addClass( "fa fa-check-circle-o" );
                    $('.fasystem_event').removeClass('fachange_history').addClass( "fa fa-asterisk" );
                    context.debugLog('init_grid onContentReady', false);
                };
            }
        }
        $("#" + this.state.grid_id).dxDataGrid(grid_properties);
        if(!this.state.isGridInit && this.state.get_count) {
            this.state.get_count = false;
            this.requestAndSetCount();
        }
        this.state.isGridInit = true;
        this.state.shouldInitGrid = false;
        //make columns fixed
        if (!(context.props.skip_init  || context.props.grid_is_on_edit_form)){
            for (var i = 0, j = grid_properties.columns.length; i < j; i++) {
                var column, dataField, attribute, attributeArray = context.state.entity_attributes.attributes;
                column = context.state.columns[i];
                dataField = column.dataField;
                attribute = get_attribute_by_field_path(attributeArray, dataField);
                if ((grid_properties.columns[i].name == "controls" || grid_properties.columns[i].name == "workflow_status")) {
                    if(document.documentElement.clientWidth <= 800) {
                        grid_properties.columns[i].fixed = false; // This was done because columns are not hiden for mobile and this setting was messing with UI
                    }else {
                        grid_properties.columns[i].fixed = true;
                        grid_properties.columns[i].fixedPosition = 'right';
                    }
                }
                if (attribute) {
                    if (attribute.entity_caption_flag) {
                        grid_properties.columns[i].fixed = true;
                        grid_properties.columns[i].fixedPosition = 'left';
                    }
                }
            }
        }
        this.debugLog('init_grid', false);
    },
    change_workflow_button_count: function(increment, field_path) {
        var context = this;
        context.state.workflow_button_count_dictionary = context.state.workflow_button_count_dictionary || {};
        if(increment) {
            if(!context.state.workflow_button_count_dictionary[field_path]) { //don't allow the same column to be counted twice just because it gets clicked again
                context.state.workflow_button_count_dictionary[field_path] = true;
                if (!context.state.workflow_button_hide_count || (context.state.workflow_button_hide_count <= 0)) {
                    context.state.workflow_button_hide_count = 1; //Acts like a counter
                }
                else {
                    context.state.workflow_button_hide_count++;
                }
            }
        }
        else {
            delete context.state.workflow_button_count_dictionary[field_path];
            if (!context.state.workflow_button_hide_count || (context.state.workflow_button_hide_count <= 1)) {
                context.state.workflow_button_hide_count = 0;
            }
            else {
                context.state.workflow_button_hide_count--;
            }
        }
    },
    run_selection_buttons_display_logic: function(e) {
        var context = this;
        context.debugLog('init_grid onSelectionChanged', true);
        var button_container = $('#button-container');
        if(context.state.workflow_button_hide_count) {
            button_container.hide();
            return;
        }

        if(!e) {
            e = context.state.last_run_selection_buttons_display_logic_event_args;
        }
        else {
            context.state.last_run_selection_buttons_display_logic_event_args = e;
        }
        if(!e) {
            return;
        }
        var grid = context.get_grid_object(e);
        if(!grid) {
            return;
        }
        if (e.selectedRowKeys.length == 0){
            context.chck_unck_all_columns(false);
        }
        else{
            if (e.selectedRowKeys.length == grid.totalCount()){
                context.chck_unck_all_columns(true);
            }
        }
        //show/hide delete button
        if(context.state.entity_access && context.state.entity_access.indexOf('d') != -1){
            if (e.selectedRowKeys.length > 0) {
                $('div[data-grid-delete-button="true"]').show();
                $('#assign-box').show();
            } else {
                $('div[data-grid-delete-button="true"]').hide();
                $('#assign-box').hide();
            }
        }
        //make a list of selected statuses
        var unique_statuses = [];
        function contains(a, obj) {
            context.debugLog('init_grid onSelectionChanged contains', true);
            if (a.length > 0){
                for (var i = 0; i < a.length; i++) {
                    if (a[i] === obj) {
                        context.debugLog('init_grid onSelectionChanged', false);
                        return true;
                    }
                }
            }
            context.debugLog('init_grid onSelectionChanged', false);
            return false;
        }
        e.selectedRowsData.forEach(function(row){
            if (!contains(unique_statuses, row.workflow_status))
                unique_statuses.push(row.workflow_status);
        });
        var button_count = 0;
        for (var status in context.state.app_object.workflow_states) {
            for (var action in context.state.app_object.workflow_states[status].workflow_actions) {
                var action_object = context.state.app_object.workflow_states[status].workflow_actions[action];
                action_object.id = action;
                button_container.each(function () {
                    var button_selector = 'div[data-grid-' + status + '-' + action.replace(/\_/g, '-') + '-button="true"][caption="' + action_object.button_caption + '"]';
                    if (status != unique_statuses[0] || 1 != unique_statuses.length) {
                        $(button_selector).hide();
                    }
                    else {
                        button_count++;
                        if ($(this).children(button_selector).length != 0) {
                            $(button_selector).show();
                        }
                        else {
                            var tmpDiv = $("<div data-grid-" + status + '-' + action.replace(/\_/g, '-') + "-button='true' class='workflow-button btn btn-primary shiny workflow_button_margin' caption='" + action_object.button_caption + "'/>");
                            tmpDiv.data('action', action_object);
                            tmpDiv.dxButton({
                                //icon: "fa fa-trash", //get icon from server.
                                text: action_object.button_caption,
                                onClick: function (_e) {
                                    //if needs comment, get it.
                                    context.debugLog('init_grid onSelectionChanged onClick', true);
                                    var action_object = $(button_selector).data('action');
                                    if (action_object.comment) {
                                        if (!action_object.button_caption) {
                                            context.setState({workflowCommentPopup: {action: action_object}});
                                        }
                                        else {
                                            context.setState({
                                                workflowCommentPopup: {
                                                    title: '',
                                                    action: action_object
                                                }
                                            });
                                        }
                                    }
                                    //send keys for the wf change.
                                    var data = {
                                        id_arr: context.get_grid_object(e).getSelectedRowKeys(),
                                        new_status: action_object.id
                                    };
                                    context.setState({workflow_change_data: data});
                                    if (!action_object.comment || (action_object.comment && context.state.workflow_comment))
                                        context.handle_workflow_change();
                                    context.debugLog('init_grid onSelectionChanged onClick', false);
                                }
                            });
                            $(this).append(tmpDiv);
                        }
                    }
                });
            }
        }
        if (button_count && (context.state.entity_access && context.state.entity_access.indexOf('u') != -1) ){
            button_container.show();
        }
        else{
            button_container.hide();
        }
        grid.option('height', context.update_height());
        grid.option('height', context.update_height);
        context.debugLog('init_grid onSelectionChanged', false);
    },
    launch_edit_form: function (data_row) {
        var context = this;
        context.debugLog('init_grid launchedit', true);
        var custom_properties = this.state.app_object.custom_properties ? this.state.app_object.custom_properties : {};
        if (data_row._id) {
            if (this.props.skip_init) {
                if (!custom_properties.edit_in_grid) {
                    var nested_popup_func = nested_entity_row_popup_function.bind(context, context);
                    var data_row = data_row;
                    if (data_row._id) {
                        data_row = $.extend(true, {}, data_row);
                        context.debugLog('init_grid onEditingStart', false);
                        return nested_popup_func(data_row);
                    }
                }
            }
            else{
                var app_object = {};
                app_object.code = context.state.app_object.edit_app_object;
                app_object.data_row = data_row;
                app_object._id = data_row._id;
                if(context.props.grid_is_on_edit_form) {
                    var ref_data = context.props.nested_reference_entity_data;
                    context.props.parent_react_entity.setState({
                        nested_reference_entity_data: ref_data,
                        reference_entity_id: data_row._id,
                        grid_is_on_edit_form: true
                    });
                }
                else {
                    context.setState({editForm: app_object}); //setState is called by the eventHandler which
                }
            }
        }
        context.debugLog('init_grid launchedit', false);
    },
    get_row_highlighting: function (row_info) {
        this.debugLog(' onRowPrepared', true);
        var context = this,
            retval;
        if (row_info.workflow_status
            && context.state.app_object
            && context.state.app_object.workflow_states
            && context.state.app_object.workflow_states[row_info.workflow_status]
            && context.state.app_object.workflow_states[row_info.workflow_status].view_options
            && context.state.app_object.workflow_states[row_info.workflow_status].view_options.highlighting) {
            //use workflow highlighting
            retval = context.apply_row_highlighting(context.state.app_object.workflow_states[row_info.workflow_status].view_options.highlighting, row_info || {});
        }
        else if (context.state.app_object
            && context.state.app_object.custom_properties
            && context.state.app_object.custom_properties.highlighting) {
            retval = context.apply_row_highlighting(context.state.app_object.custom_properties.highlighting, row_info || {});
        }
        this.debugLog('onRowPrepared', false);
        return retval;
    },
    init_calendar: function (force_ref_load){
        this.debugLog('init_calendar', true);
        if  (this.state.app_object && this.state.app_object.custom_properties){
            var descriptionExpr = this.state.app_object.custom_properties.descriptionExpr;
            descriptionExpr = descriptionExpr?descriptionExpr:'doc_num';
            var startDateExpr=this.state.app_object.custom_properties.startDateExpr;
            startDateExpr = startDateExpr?startDateExpr:'contract_date';
            var endDateExpr=this.state.app_object.custom_properties.endDateExpr;
            endDateExpr = endDateExpr?endDateExpr:'expiration_date';
            this.init_calendar_datasource();
            this.setState({descriptionExpr:descriptionExpr, startDateExpr:startDateExpr, endDateExpr:endDateExpr, resources:this.build_resources()});
            this.debugLog('init_calendar', false);
            return true;
        }
        else{
            this.debugLog('init_calendar', false);
            return false;
        }
    },
    rebuild_resources: function(){
        this.setState({resources:this.build_resources()})
    },
    build_resources: function (){
        var retval = [],
            workflow_states = this.state.app_object.workflow_states,
            workflow_states_ids = workflow_states?Object.keys(workflow_states):[],
            current_state;
        for (var i = 0, l = workflow_states_ids.length; i < l; i++){
            current_state = workflow_states[workflow_states_ids[i]];
            if (current_state){
                retval.push({id:workflow_states_ids[i], text:current_state.caption, color:current_state.view_options.class_color});
            }
        }
        retval.push({
            color:'teal',
            id:'none',
            text:'None'
        });
        return [{dataSource:retval, label:'Status', field:'resources'}];
    },
    apply_row_highlighting: function (highlighting_obj, entity_inst) {
        this.debugLog('apply_row_highlighting', true);
        var retval,
            cur_priority = null;
        if (typeof highlighting_obj === 'object'){
            for (var color in highlighting_obj) {
                //code to iterate through all conditions children and convert date strings and integers into date objects.
                var conditions = highlighting_obj[color].conditions;
                highlighting_obj[color].conditions = this.highlighting_recursive_fix(conditions, 'conditions', entity_inst);
                if (matchConditionObj.match(entity_inst, highlighting_obj[color].conditions)) {
                    if ((cur_priority == null) || highlighting_obj[color].priority < cur_priority) {
                        retval = color;
                        cur_priority = highlighting_obj[color].priority;
                    }
                }
            }
        }
        this.debugLog('apply_row_highlighting', false);
        return retval;
    },
    highlighting_recursive_fix: function (obj, objId, entity_inst){
        var t = typeof obj, retval, context = this;
        if ("object" == t){
            var keys = Object.keys(obj);
            keys.forEach(function (key){//iterate through conditions object
                if (!obj[key]) {//if falsy delete it to prevent bad matches.
                    if (undefined === entity_inst[key]) {
                        delete obj[key];
                    }
                }
                else{
                    obj[key] = context.highlighting_recursive_fix(obj[key], key, entity_inst); //fix condition children
                    if (_.isDate(obj[key]) && entity_inst && entity_inst[objId] && !_.isDate(entity_inst[objId])) { //if condition is a date, but the target is not, convert the target.
                        try{entity_inst[objId] = new Date(entity_inst[objId]);}catch(er){}
                    }
                }
            });
            retval = obj; //after all children are fixed return resulting object.
        }
        else if("array" == t){
            for(var i = 0; i < obj.length; i++){
                obj[i] = context.highlighting_recursive_fix(obj[i]);
            }
            retval = obj;
        }
        else if("string" == t){
            try {
                retval = new Date(obj);
                if(isNaN(retval.getTime())){
                    retval = obj;
                }
            }
            catch (e) {
                retval = obj;
            }
        }
        else {
            retval = obj;
        }
        return retval;
    },
    //Hides columns without entity_caption or status for smaller resolution screens
    hide_columns: function(grid, value){
        this.debugLog('hide_columns', true);
        var context = this,
            column,
            dataField,
            attribute,
            attributeArray = context.state.entity_attributes.attributes,
            visible,
            numberofEntityCaption =0;
        for(var i = 0, l = context.state.columns.length; i<l; i++){
            column = context.state.columns[i];
            dataField = column.dataField;
            if (dataField){
                attribute = get_attribute_by_field_path(attributeArray, dataField);
                if (attribute){
                    visible = value || attribute.caption == "Status" || attribute.entity_caption_flag;
                    visible = visible &&  !(column.dataField == "workflow_status" && this.props.conditions && this.props.conditions.workflow_status);
                    if(document.documentElement.clientWidth <= 410 && numberofEntityCaption >= 2 ){
                        visible = true; // To actually hide set this to false 
                    }
                    if(document.documentElement.clientWidth <= 610 && numberofEntityCaption >= 3 ){
                        visible = true; // To actually hide set this to false
                    }
                    if(attribute.primary_key){
                        visible = true;
                    }
                    if (column.visible != visible) {
                        column.visible = visible;
                    }
                    if(visible){
                        numberofEntityCaption = numberofEntityCaption +1;
                    }
                }//document.documentElement.clientWidth <= 800
            }
        }
        if(!value){
            grid.option('columnAutoWidth', true);  // To actually hide set this to false
        }
        else{
            grid.option('columnAutoWidth', true);
        }
        //grid.option('columns', context.state.columns); // To actually hide uncomment this line
        this.debugLog('hide_columns', false);
    },
    on_error_close: function() {
        this.debugLog('on_error_close', true);
        this.setState({error:undefined});
        this.debugLog('on_error_close', false);
    },
    init_grid_columns: function(for_export){
        this.debugLog('init_grid_columns', true);
        var columns = [],
            context = this,
            found = false,
            first_string_column = undefined,
            first_visible_column = undefined;
        context.state.entity_attributes.attributes.forEach(function(attribute){
            if(!first_visible_column && attribute.list_visible) first_visible_column = attribute;
            if (!first_string_column && attribute.type == "String" && attribute.list_visible) first_string_column = attribute;
            if (attribute.list_visible && attribute.entity_caption_flag){
                found = true;
            }
        });
        if (!found){
            if (first_string_column){
                first_string_column.entity_caption_flag = true;
            }
            else if (first_visible_column) {
                first_visible_column.entity_caption_flag = true;
            }
        }
        for (var i = 0; this.state.entity_attributes && i < this.state.entity_attributes.attributes.length; i++) {
            var attribute = this.state.entity_attributes.attributes[i];
            if (!attribute.list_visible) {
                continue;
            }
            if (attribute.type == "Mixed" || attribute.is_array) {
                continue;
            }
            var column = {name: attribute.field_path, dataField: attribute.field_path, caption: attribute.caption};
            if (attribute.list_of_values) {
                var tempAttribute = attribute.list_of_values;
                column.allowHeaderFiltering = true;
                column.headerFilter = {
                    dataSource: {
                        load: function (loadOptions) {
                            var res = [];
                            for (var i = 0; i < tempAttribute.length; i++) {
                                res.push({text: tempAttribute[i].value, value: tempAttribute[i].code});
                            }
                            return res;
                        }
                    }
                }
            }
            else {
                column.allowHeaderFiltering = false;
            }
            var allow_column_edit = false;
            //////////in-grid editing not allowed for read-only fields or fields not marked as grid_editable//////////////
            if (attribute.read_only || !attribute.grid_editable) {
                if (!context.props.grid_is_on_edit_form && !this.props.skip_init) { //custom handling is in place already for these in the onEditingStart eventHandler
                    column.allowEditing = false;
                }
            }
            else if (attribute.grid_editable) {
                allow_column_edit = true;
            }
            var filter = get_parameter(column.dataField);
            if (filter) {
                column.filterValue = filter;
            }
            var type = attribute.attribute_type == null ? attribute.db_type : attribute.attribute_type;
            column.dataType = 'string';
            if(this.props.app_object && this.props.app_object.entity=="xenforma_note") {
                column.visible = false;
            }
            var bindFunction = function(column){
                column.calculateCellValue = function(rowData){
                    return get_json_data_using_field_paths(column.dataField, rowData);
                }
            }(column);
            switch (type) {
                case "Image":{
                    column.cellTemplate = function (container, options) {
                        if (options.value) {
                            $("<div style='float:left;background-image:url("+options.value+");background-repeat:none;background-position:center center;width:25px;height:25px;background-size:cover;'></div>").appendTo(container);
                        }
                    };
                    column.allowFiltering = false;
                    break;
                }
                case "Recurrent":{
                    column.allowFiltering = false;
                    column.cellTemplate = function (container, options) {
                        if (options.value) {
                            var value = options.value;
                            if (value.slice(0, 6) == 'RRULE:') {
                                value = value.substr(6);
                            }
                            (container).html(RRule.fromString(value).toText());
                        }
                    };
                    break;
                }
                case "Html":{
                    column.cellTemplate = function (container, options) {
                        if (options.value && options.value != '') {
                            $("<a href='#' >" + R.view + "</a>")
                                .on('click', function (e) {
                                    context.popup.option('title', options.column.caption);
                                    context.popup.show();
                                    $('#' + context.state.scrollViewContentElementId).html(options.value);
                                    e.preventDefault();
                                })
                                .appendTo(container);
                        }
                    };
                    break;
                }
                case "YesNo":{
                    column.falseText = R.label_no;
                    column.trueText = R.label_yes;
                    column.cellTemplate = function (container, options) {
                        if (options.value && options.value != '') {
                            (container).html(R.label_yes);
                        }
                        else {
                            (container).html(R.label_no);
                        }
                    };
                    break;
                }
                case "Boolean":
                    break;
                case "CheckBox":
                    break;
                case "MaskedTextBox":
                    break;
                case "Section":
                    column.allowFiltering = true;
                    column.dataType = 'string';
                    break;
                case "MultiLineTextBox":
                    // https://www.devexpress.com/Support/Center/Question/Details/T298005
                    break;
                case "Date":{
                    column.dataType = 'date';
                    var bindFunction = function (column) {
                        column.calculateCellValue = function (rowData) {
                            var value = get_json_data_using_field_paths(column.dataField, rowData);
                            if ('string' == typeof value){
                                value = moment.utc(value).format('MM/DD/YY');
                            }
                            else if (!value){
                                value = '';
                            }
                            return value;
                        };
                    }(column);
                    break;
                }
                case "percent":{
                    column.format = {
                        type: 'percent', precision: 2
                    };
                    column.dataType = 'number';
                    break;
                }
                case "currency":{
                    column.format = {
                        type: 'currency', precision: 2
                    };
                    column.dataType = 'number';
                    break;
                }
                case "Number":{
                        column.dataType = 'number';
                        break;
                    }
                case "DateTime":{
                    column.dataType = 'date';
                    var bindFunction = function (column) {
                        column.calculateCellValue = function (rowData) {
                            var value = get_json_data_using_field_paths(column.dataField, rowData);
                            return value?moment(value).format('MM/DD/YY hh:mm a'):'';
                        };
                    }(column);
                    break;
                }
                case "DateTimeLocal":{
                    column.dataType = 'date';
                    var bindFunction = function (column) {
                        column.calculateCellValue = function (rowData) {
                            var value = get_json_data_using_field_paths(column.dataField, rowData);
                            return value?moment(value).format('MM/DD/YY hh:mm a'):'';
                        };
                    }(column);
                    break;
                }
                case "Time":{
                    var bindFunction = function (column) {
                        column.calculateCellValue = function (rowData) {
                            var value = get_json_data_using_field_paths(column.dataField, rowData);
                            return value?moment(value).format('hh:mm:ss a'):'';
                        };
                    }(column);
                    break;
                }
                case "user": {
                    if (attribute.is_nested_entity && attribute.data_is_nested == false && !attribute.is_array) {
                        if (for_export) {
                            column.allowFiltering = true;
                            column.dataType = 'string';
                            column.customizeText = function (data) {
                                if (!data || !data.value || !data.value.caption) {
                                    return null;
                                }
                                return data.value.caption;
                            };
                        }
                        else {
                            column.allowFiltering = true;
                            column.dataType = 'string';
                            column.cellTemplate = function (container, options) {
                                var avatar_out='data:image/png;base64,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';
                                if (typeof options.value == "object" && options.value != null) {
                                    var name = options.value.caption || options.value.entity_id;
                                    var iconUser=options.value.image;
                                    var html1='<span style="margin-top:5px;text-align:left;">' + name + '</span>';
                                    var html2 = iconUser == undefined ? '<i class="fa fa-user" style="margin-right:5px;;margin-left:5px;font-size:18px;" aria-hidden="true">' :  "<div style='background-image:url("+iconUser+");background-repeat:none;background-position:center center;width:25px;height:25px;float:left;margin-right:5px;background-size:cover;'></div>";                                    if (iconUser) {
                                        if( (avatar_out == options.value.image)  ) iconUser='';
                                        if(!iconUser){
                                            $("<span>&nbsp;</span>").prependTo(container);
                                            $('<i class="fa fa-user" style="float:left;font-size:18px;" aria-hidden="true"></i>').prependTo(container);
                                        }
                                        else{
                                            $("<span>&nbsp;</span>").prependTo(container);
                                        }
                                    }
                                    else{
                                        $("<span>&nbsp;</span>").prependTo(container);
                                        $('<i class="fa fa-user" style="float:left;  font-size:18px;margin-left:5px;" aria-hidden="true"></i>').prependTo(container);
                                    }
                                    container.html('<table  width="100%" height="100%" cellpadding="0" cellspacing="0" ><tr><td valign="center" width="10" >'+ html2 +' </td> <td valign="center" style="text-align:left;margin-left:5px;"> '+html1+'</td></tr></table>');
                                    options.displayValue = name;
                                    options.value = name;
                                }
                                else{
                                    return options.value;
                                }
                            }
                        }
                    }
                    break;
                }
                case "String": {
                    column.dataType = 'string';
                    if (this.state.app_object && this.state.app_object.workflow_states) {
                        if (column.dataField == "workflow_status") {
                            column.cellTemplate = function (container, options) {
                                var workflowState = context.state.app_object.workflow_states[options.value];
                                if ((workflowState && workflowState.caption && (workflowState.caption.trim() != ""))) {
                                    var class_name = "label label-";
                                    if (workflowState && workflowState.view_options && workflowState.view_options.class_color) {
                                        class_name = class_name + workflowState.view_options.class_color;
                                    }
                                    else {
                                        class_name = class_name + "palegreen";
                                    }
                                    (container).html("<span><span class='" + class_name + "'>" + workflowState.caption.toUpperCase() + "</span></span>");
                                }
                            };
                            if (!context.props.conditions || !context.props.conditions.workflow_status) {
                                var workflowStates = [];
                                for (var propertyName in context.state.app_object.workflow_states) {
                                    var workflowState = context.state.app_object.workflow_states[propertyName];
                                    if (workflowState.caption && (workflowState.caption.trim() != "")) {
                                        workflowStates.push({value: workflowState.caption, code: propertyName});
                                    }
                                }
                                if (workflowStates.length > 0) {
                                    column.lookup = {
                                        dataSource: workflowStates,
                                        valueExpr: 'code',
                                        displayExpr: 'value'
                                    };
                                }
                            }
                        }
                    }
                    if (attribute.list_of_values) {
                        if(this.props.app_object) {
                            if(this.props.app_object.entity=="xenforma_note") {
                                column.visible = true;
                                column.dataType = 'data';
                            }
                        }
                        var valuesList = attribute.list_of_values;
                        if(Array.isArray(valuesList)) {
                            column.lookup = {dataSource: valuesList, valueExpr: 'code', displayExpr: 'value'};
                        }
                    }
                    break;
                }
                default:{
                    if(!attribute.is_array) {
                        column.allowFiltering = true;
                        column.dataType = 'string';
                    }
                    if (attribute.is_nested_entity && !attribute.data_is_nested) {
                        //column is a nested entity
                        var bindFunction = function (column) {
                            column.calculateCellValue = function (rowData) {
                                var value = get_json_data_using_field_paths(column.dataField, rowData);
                                if (value) {
                                    var name = value.value || value.caption;
                                    return name;
                                }
                                return value;
                            };
                        }(column);
                        column.reference_type = type;
                        if(allow_column_edit) {
                            column.cellTemplate = function (cellElement, cellInfo) { //Not clickable
                                cellElement.addClass('img-container');
                                cellElement.text(cellInfo.value)
                                    .appendTo(cellElement);
                                var cellData = cellInfo.data[cellInfo.column.dataField];
                                var image = cellData ? cellData.image : null;
                                if (image) {
                                    $('<img style=height:21px;margin-right:3px />')
                                        .attr("src", image)
                                        .prependTo(cellElement);
                                }
                            };
                            column.editCellTemplate = function (cellDataSource) {
                                return function (cellElement, cellInfo) {
                                    var divElement = document.createElement("div");
                                    cellElement.html(divElement);
                                    ReactDOM.render(<EditorDevExtremeLookup
                                        dataSource={cellDataSource}
                                        displayExpr="caption"
                                        valueExpr="entity_id"
                                        value={cellInfo.value||''}
                                        add_button={false}
                                        edit_button={false}
                                        readOnly={false}
                                        is_in_grid_edit={true}
                                        onDisposing={function(local_event) {
                                            if(cellInfo.key) {
                                                context.change_workflow_button_count(false, cellInfo.column.dataField + cellInfo.key);
                                            }
                                            context.run_selection_buttons_display_logic();
                                        }}
                                        onChange={function(new_value) {
                                        context.force_edit_refresh = true;
                                        var cell_value = new_value;
                                        if(new_value && (typeof new_value == "object") && !new_value.caption && cellDataSource && cellDataSource._items && cellDataSource._items.filter) {  //for some reason this object does not have the caption, so we have to grab it from the data source
                                            cell_value = cellDataSource._items.filter(function(a) {return a.entity_id == new_value.entity_id});
                                            if(cell_value && cell_value.length) {
                                                cell_value = cell_value[0];
                                            }
                                            else {
                                                cell_value = new_value;
                                            }
                                        }
                                        cellInfo.setValue(cell_value);
                                    }}
                                        placeholder={R.start_typing_to_search?R.start_typing_to_search:'Start typing to search...'}
                                    />, divElement);
                                };
                            }(context.build_datasource(column.reference_type, attribute.field_path, false));
                        }
                        else if(attribute.read_only) {
                            column.cellTemplate = function (cellElement, cellInfo) {
                                cellElement.addClass('img-container');
                                cellElement.text(cellInfo.value)
                                    .appendTo(cellElement);
                                var cellData = cellInfo.data[cellInfo.column.dataField];
                                var image = cellData ? cellData.image : null;
                                if (image) {
                                    $('<img style=height:21px;margin-right:3px />')
                                        .attr("src", image)
                                        .prependTo(cellElement);
                                }
                            };
                        }
                        else {
                            column.cellTemplate = function (cellElement, cellInfo) {
                                cellElement.addClass('img-container');
                                cellElement.addClass('dx-link')
                                    .text(cellInfo.value)
                                    .on('dxclick', function () {
                                        if(cellInfo.data[cellInfo.column.dataField]) {
                                        var app_object = {
                                            code: cellInfo.column.reference_type + '_default_edit_form',
                                            _id: cellInfo.data[cellInfo.column.dataField].entity_id
                                        };
                                        context.setState({editForm: app_object});
                                        }
                                    })
                                    .appendTo(cellElement);
                                var cellData = cellInfo.data[cellInfo.column.dataField];
                                var image = cellData ? cellData.image : null;
                                if (image) {
                                    $('<img style=height:21px;margin-right:3px />')
                                        .attr("src", image)
                                        .prependTo(cellElement);
                                }
                            };
                        }
                    }
                    else if (attribute.entity_reference_variant){
                        var bindFunction = function (column) {
                            column.calculateCellValue = function (rowData) {
                                var value = get_json_data_using_field_paths(column.dataField, rowData);
                                if (value) {
                                    var name = value.value || value.caption;
                                    return name;
                                }
                                return value;
                            };
                        }(column);
                        column.reference_type = type;
                        column.allowEditing = false;
                        allow_column_edit = false;
                        column.cellTemplate = function (cellElement, cellInfo){
                            cellElement.addClass('img-container');
                            cellElement.addClass('dx-link')
                                .text(cellInfo.value)
                                .on('dxclick', function () {
                                    var app_object = {
                                        code : cellInfo.data[cellInfo.column.dataField].entity_name + '_default_edit_form',
                                        _id : cellInfo.data[cellInfo.column.dataField].entity_id
                                    };
                                    context.setState({editForm: app_object});
                                })
                                .appendTo(cellElement);
                            var cellData = cellInfo.data[cellInfo.column.dataField];
                            var image = cellData?cellData.image:null;
                            if (image){
                                $('<img style=height:21px;margin-right:3px />')
                                    .attr("src", image)
                                    .prependTo(cellElement);
                            }
                        }
                    }
                    else if (attribute.primary_key) {
                        //column is the key field
                        var bindFunction = function (column) {
                            column.calculateCellValue = function (rowData) {
                                var value = get_json_data_using_field_paths(column.dataField, rowData);
                                if (typeof value == "object" && value != null) {
                                    var name = value.caption || value.entity_id;
                                    return name;
                                } else {
                                    return value;
                                }
                            };
                        }(column);
                        column.reference_type = type;
                        if(!allow_column_edit) {  //make this a hyperlink
                            column.cellTemplate = function (cellElement, cellInfo) {
                                cellElement.addClass('dx-link')
                                    .text(cellInfo.value)
                                    .on('dxclick', function () {
                                        context.launch_edit_form(cellInfo.data);
                                    })
                                    .appendTo(cellElement);
                            };
                        }
                        column.customizeText = function (cellInfo) {
                            if (typeof cellInfo.value == "object" && cellInfo.value != null) {
                                var name = cellInfo.value.caption || cellInfo.value.entity_id;
                                return name;
                            }
                            else {
                                return cellInfo.valueText;
                            }
                        }
                    }
                    else {
                        var bindFunction = function (column) {
                            column.calculateCellValue = function (rowData) {
                                var value = get_json_data_using_field_paths(column.dataField, rowData);
                                return value;
                            }
                        }(column);
                        column.customizeText = function (cellInfo) {
                            if (typeof cellInfo.value == "object" && cellInfo.value != null) {
                                var name = cellInfo.value.caption || cellInfo.value.entity_id;
                                return name;
                            } else {
                                return cellInfo.valueText;
                            }
                        }
                    }
                    break;
                }
            }
            if(allow_column_edit) {
                column.allow_column_edit = true;
            }
            columns.push(column);
        }
        //after all columns are done...
        var command_column = {};
        command_column.width = 75;
        command_column.name = 'controls';
        command_column.allowSorting = false;
        command_column.allowFiltering = false;
        command_column.allowEditing = false;
        command_column.cellTemplate = function(container, options){
            var grid = context.get_grid_object();
            if(context.state.app_object.custom_properties.editable && !context.state.app_object.custom_properties.disable_delete){
                if(!context.props.skip_init && !context.props.grid_is_on_edit_form) {
                    if (context.state.entity_access && context.state.entity_access.indexOf('c')!=-1) {
                        $('<span id="duplicate" class="dx-link fa fa-files-o"></span>')
                            .on('dxclick', function () {
                                //THIS WILL DUPLICATE
                                var app_object = {};
                                app_object.code = context.state.app_object.edit_app_object;
                                app_object.forDuplication = true;
                                if (context.props.grid_is_on_edit_form) {
                                    var ref_data = context.props.nested_reference_entity_data;
                                    context.props.parent_react_entity.setState({
                                        nested_reference_entity_data: ref_data,
                                        grid_is_on_edit_form: true
                                    });
                                }
                                else {
                                    context.setState({editForm: app_object, duplicate_id: options.data._id});
                                }
                            }).appendTo(container);
                    }
                }
                else{
                    if ((!context.state.entity_access || context.state.entity_access.indexOf('d')!=-1)){
                        $('<span id="delete" class="dx-link fa fa-trash-o"></span>')
                            .on('dxclick', function(){
                                if (context.props.skip_init || context.props.grid_is_on_edit_form){
                                    context.props.parent_react_entity.set_confirming(true);
                                }
                                if(grid) {
                                    grid.deleteRow(options.rowIndex);
                                }
                            }).appendTo(container);
                    }
                }
            }
            $('<span id="edit" class="dx-link fa fa-pencil-square-o" style=margin-left:10px></span>')
                .on('dxclick', function(){
                    context.launch_edit_form(options.data);
                }).appendTo(container);
            if (context.state.reports){
                $('<span class="dx-link fa fa-print" style=margin-left:10px></span>')
                    .on('dxclick', function () {
                        var reports = context.state.reports;
                        if(reports.length > 1) {
                            context.chooseReport(event.target, options.key);
                        }
                        else{
                            context.printReportRecursive(reports,options.key);
                        }
                    })
                    .appendTo(container);
            }
        };
        columns.push(command_column);
        this.debugLog('init_grid_columns', false);
        if(for_export) {
            return columns;
        }
        else {
            this.state.columns = columns;
        }
    },
    open_popover:function(id_tag,callback,target){
        this.debugLog('open_popover', true);
        if(typeof target == "string"){
            target = "#" + target;
        }
        var popover_desc = $("#id"+id_tag).dxPopover({
            target: target,
            position: "top",
            width: 300,
            onContentReady: callback
        }).dxPopover("instance");
        popover_desc.show();
        this.setState({popover:popover_desc});
        this.debugLog('open_popover', false);
    },
    openDescriptionGrid: function(idGrid,e){
        this.debugLog('openDescriptionGrid', true);
        var context= this;
        $(".description_grid[data-unique-id='"+idGrid+"' ]").slideToggle(function(){
            if((!context.props.skip_init && !context.props.grid_is_on_edit_form) || (context.props.skip_init == false && context.props.grid_is_on_edit_form == false)){
                context.updateDimensions();
            }
        });
        this.debugLog('openDescriptionGrid', false);
    },
    openBodyGrid: function (idGrid){
        this.debugLog('openBodyGrid', true);
        var context = this;
        context.is_grid_toggling = true;
        var gridInstance = this.get_grid_object();
        if(gridInstance) {
            gridInstance.option('columnAutoWidth', true);
        }
        $(".widget-body[data-unique-id='" + idGrid + "']").slideToggle("slow", function () {
            context.is_grid_toggling = false;
            var element = $("i[id='_toggle'][data-unique-id='"+idGrid+"']");
            var elementX= element.attr("class");
            if(elementX && elementX.indexOf("plus")!=-1){
                element.removeClass().addClass("fa fa-minus");
                context.props.set_open_state(true);
                context.setState({is_open:true});
                if(context.props.grid_is_on_edit_form) {
                    switch(context.state.selectedViewsetting){
                        case 'data_list':
                            context.init_grid(true);
                            break;
                        case 'tree_view':
                            break;
                        case 'calendar_view':
                            break;
                        case 'map_view':
                            break;
                    }
                }
            }
            else{
                element.removeClass().addClass("fa fa-plus");
                context.props.set_open_state(false);
                context.setState({is_open:false});
                if(context.props.grid_is_on_edit_form) {
                    switch(context.state.selectedViewsetting){
                        case 'data_list':
                            context.init_grid(true);
                            break;
                        case 'tree_view':
                            break;
                        case 'calendar_view':
                            break;
                        case 'map_view':
                            break;
                    }
                    context.requestAndSetCount();
                }
            }
        });
        var currentText=$.trim($(".btn-default[data-unique-id='"+idGrid+"']").text()), newText;
        currentText=="Hide" ? newText="<i class='fa fa-expand'></i>Show" : newText="<i class='fa fa-compress'></i>Hide";
        $(".btn-default[data-unique-id="+idGrid+"]").html(newText);
        var desc_button = $("i[data-unique-id='"+idGrid+"' ][data-type-element!='headBtn' ]");
        if (this.state.is_open == desc_button.is(':visible')){
            context.is_desc_button_toggling = true;
            desc_button.slideToggle(400, function(){context.is_desc_button_toggling = false});
        }
        this.debugLog('openBodyGrid', false);
        return null;
    },
    requestAndSetCount: function() {
        this.debugLog('requestAndSetCount', true);
        var context = this;
        if(context.props.grid_is_on_edit_form) {
            var entity_name = this.state.entity_attributes.entity;
            var success_func = function (data) {
                context.debugLog('requestAndSetCount success_func', true);
                var count = data.count;
                context.setState({record_count: count});
                context.debugLog('requestAndSetCount success_func', false);
            };
            var error_func = function (error) {
                context.debugLog('requestAndSetCount success_func', true);
                context.debugLog('requestAndSetCount success_func', false);
            };
            invoke_method(entity_name, "find_count", {conditions: this.props.conditions}, success_func, error_func);
        }
        this.debugLog('requestAndSetCount', false);
    },
    treeViewClick:function(e){
        this.debugLog('treeViewClick', true);
        var context = this;
        if (e.itemData.id) {
            var app_object = {};
            app_object.code = context.state.app_object.edit_app_object;
            app_object.data_row = e.itemIndex;
            app_object._id = e.itemData.id;
            if(context.props.grid_is_on_edit_form) {
                var ref_data = context.props.nested_reference_entity_data;
                context.props.parent_react_entity.setState({
                    nested_reference_entity_data: ref_data,
                    reference_entity_id: e.itemData.id,
                    grid_is_on_edit_form: true
                });
            }
            else {
                context.setState({editForm: app_object});
            }
        }
        this.debugLog('treeViewClick', false);
    },
    mapViewClick:function(e){
        this.debugLog('treeViewClick', true);
        var context = this,
            data = this.state.entity_instances;
        e.itemData = find_by_field('_id', e.target.id, data);
        if (e.itemData) {
            var app_object = {};
            app_object.code = context.state.app_object.edit_app_object;
            app_object.data_row = find_index_by_id(data, e.itemData._id);
            app_object._id = e.itemData._id;
            if(context.props.grid_is_on_edit_form) {
                var ref_data = context.props.nested_reference_entity_data;
                context.props.parent_react_entity.setState({
                    nested_reference_entity_data: ref_data,
                    reference_entity_id: e.itemData._id,
                    grid_is_on_edit_form: true
                });
            }
            else {
                context.setState({editForm: app_object});
            }
        }
        this.debugLog('treeViewClick', false);
    },
    change_view_state:function(selected){
        this.debugLog('change_view_state', true);
        if(selected != this.state.selectedViewsetting) {
            var context = this;
            context.display_loader();
            if (context.state.selectedViewsetting == "data_list"){
                var grid = context.get_grid_object();
                if(grid) {
                    context.row_count = grid.totalCount();
                }
            }
            context.setState({selectedViewsetting: selected});
            switch(selected){
                case "data_list":
                    var conditions = this.state.export_grid_conditions;
                    this.getInitialState();
                    this.state.export_grid_conditions = conditions;
                    localStorage.setItem('selectedViewsetting', selected);
                    this.display_loader();
                    window.addEventListener("resize", this.updateDimensions);
                    window.addEventListener("orientationchange", this.on_orientation_change);
                    $(this.popupContentElement).dxScrollView({
                        useNative: true,
                        scrollByThumb: true
                    }).dxScrollView("instance");
                    this.popup = $(this.popupElement).dxPopup({
                        showTitle: true
                    }).dxPopup("instance");
                    if (this.props.skip_init && this.state.shouldInitGrid) { //initialize nested datagrids
                        this.init_grid_columns();
                        this.init_grid();
                    }
                    break;
                case "tree_view":
                    localStorage.setItem('selectedViewsetting', selected);
                    this.get_treeview_data();
                    break;
                case "calendar_view":
                    this.calendar = this.init_calendar(this.props.skip_init && this.state.shouldInitGrid && !this.props.grid_is_on_edit_form);
                    localStorage.setItem('selectedViewsetting', selected);
                    $(window).trigger('resize')
                    break;
                case "map_view":
                    localStorage.setItem('selectedViewsetting', selected);
                    this.get_mapview_data();
                    break;
            }
        }
        this.debugLog('change_view_state', false);
    },
    get_treeview_data:function(){
        this.debugLog('get_treeview_data', true);
        var context = this;
        if(!context.treeview_searching) {
            var send_data = {
                conditions: {},
                last_id: undefined
            };
            if(context.state.export_grid_conditions){
                send_data.conditions = context.state.export_grid_conditions;
            }
            var hierarchical_tree = function(item_arr, identifier_field, parent_field, children_field, transformation_function) {
                if(!item_arr || !item_arr.length || !Array.isArray(item_arr)) {
                    return {};
                }
                var dic_func = function(entry) {
                    entry = (transformation_function) ? transformation_function(entry) : entry;
                    var ret_entry = {key: entry[identifier_field]};
                    ret_entry.value = entry;
                    return ret_entry;
                };
                var dictionary_of_entities_by_identifier = convert_to_dictionary(item_arr, dic_func);
                dictionary_tree(dictionary_of_entities_by_identifier, parent_field, children_field);
                return to_array(dictionary_of_entities_by_identifier);
            };
            var dictionary_tree = function(dictionary_of_all_entities, parent_field, children_field) {
                var delete_children_arr = [];
                for(var entity_id in dictionary_of_all_entities) {
                    if(dictionary_of_all_entities.hasOwnProperty(entity_id) && dictionary_of_all_entities[entity_id]) {
                        var entity = dictionary_of_all_entities[entity_id];
                        var parent_entity_id = entity[parent_field];
                        if(parent_entity_id != null) {
                            if(dictionary_of_all_entities[parent_entity_id]) {
                                dictionary_of_all_entities[parent_entity_id][children_field] = dictionary_of_all_entities[parent_entity_id][children_field] || [];
                                dictionary_of_all_entities[parent_entity_id][children_field].push(entity);
                                delete_children_arr.push(entity_id);
                            }
                        }
                    }
                }
                if(delete_children_arr.length) {
                    for(var i = 0; i < delete_children_arr.length; i++) {
                        delete dictionary_of_all_entities[delete_children_arr[i]];
                    }
                }
                return false;
            };
            var success_func = function (data) {
                context.debugLog('get_treeview_data success_func', true);
                //SORT_TREE
                data.entity_instances.sort(function(a, b){
                    a = make_friendly_caption(context.state.entity_attributes.caption_fields, a, context.state.entity_attributes.attributes);
                    b = make_friendly_caption(context.state.entity_attributes.caption_fields, b, context.state.entity_attributes.attributes);
                    if(a && b){
                        return ((a.toUpperCase() > b.toUpperCase())) - ((a.toUpperCase() < b.toUpperCase()));
                    }
                    else{
                        return !a?!b?0:-1:1;
                    }
                });
                var datasource = hierarchical_tree(data.entity_instances, "id", "hierarchical_parent", "items", function (a) {
                    return {
                        id: a._id,
                        text: make_friendly_caption(context.state.entity_attributes.caption_fields, a, context.state.entity_attributes.attributes),
                        hierarchical_parent: (a.hierarchical_parent) ? a.hierarchical_parent.entity_id : null,
                        expanded: true
                    };
                });
                context.setState({treeview_datasource: (datasource)});
                context.treeview_searching = false;
                context.debugLog('get_treeview_data success_func', false);
            };
            var error_func = function (error) {
                context.debugLog('get_treeview_data error_func', true);
                if (error.responseJSON) {
                    context.setState({error: error.responseJSON.message});
                } else if (error.message) {
                    context.setState({error: error.message});
                } else if (error) {
                    context.setState({error: error});
                }
                context.treeview_searching = false;
                context.debugLog('get_treeview_data error_func', false);
            };
            var complete_func = function (e) {
                context.debugLog('get_treeview_data complete_func', true);
                context.state.loading = false;
                context.props.handle_executing(false);
                context.debugLog('get_treeview_data complete_func', false);
            };
            context.treeview_searching = true;
            invoke_method(context.state.entity_attributes.entity, "find_all", send_data, success_func, error_func, complete_func);
        }
        this.debugLog('get_treeview_data', false);
    },
    get_mapview_data:function(){
        this.debugLog('get_mapview_data', true);
        var context = this;
        if(!context.mapview_searching) {
            var send_data = {
                conditions: {},
                last_id: undefined
            };
            if(context.state.export_grid_conditions){
                send_data.conditions = context.state.export_grid_conditions;
            }
            if (context.row_count){
                send_data.limit = context.row_count;
            }
            else{
                send_data.limit = 50;
            }
            var success_func = function (data) {
                context.debugLog('get_mapview_data success_func', true);
                var caption_fields = context.state.entity_attributes.caption_fields,
                    mapMarkers = [],
                    mapFields = context.state.app_object.custom_properties.map_fields;
                for (var j = 0, v = mapFields.length; j<v; j++){
                    var coordinates_field = mapFields[j].coordinates_field;
                    var marker_props = data.entity_instances;
                    for(var i =0; i<marker_props.length; i++) {
                        var new_marker = {};
                        var tooltip_text = "";
                        for(var l =0; l<caption_fields.length; l++) {
                            var caption_name = caption_fields[l];
                            var caption_values = marker_props[i][caption_name];
                            if (typeof caption_values == "object"){
                                caption_values ="";
                            }
                            if(!tooltip_text && caption_values){
                                tooltip_text = caption_values;
                            }
                            else if(caption_values) {
                                tooltip_text = tooltip_text +" - " + caption_values;
                            }
                        }
                        new_marker.title = marker_props[i].doc_num;
                        new_marker.tooltip = {text: "<a id='" + marker_props[i]._id + "' class='map-tooltip'>"+tooltip_text+"</a>", isShown: false};
                        var item = get_json_data_using_field_paths(coordinates_field,marker_props[i]);
                        if(item){
                            new_marker.location = [item.latitude, item.longitude];
                            mapMarkers.push(new_marker);
                        }
                    }
                }
                context.setState({entity_instances:data.entity_instances,map_markers:mapMarkers});
                context.mapview_searching = false;
                context.debugLog('get_mapview_data success_func', false);
            };
            var error_func = function (error) {
                context.debugLog('get_mapview_data error_func', true);
                if (error.responseJSON) {
                    context.setState({error: error.responseJSON.message});
                } else if (error.message) {
                    context.setState({error: error.message});
                } else if (error) {
                    context.setState({error: error});
                }
                context.mapview_searching = false;
                context.debugLog('get_mapview_data error_func', false);
            };
            var complete_func = function (e) {
                context.debugLog('get_mapview_data complete_func', true);
                context.state.loading = false;
                context.last_load = 'map_view';
                context.props.handle_executing(false);
                context.debugLog('get_mapview_data complete_func', false);
            };
            context.mapview_searching = true;
            invoke_method(context.state.entity_attributes.entity, "get_map_data", send_data, success_func, error_func, complete_func);
        }
        this.debugLog('get_treeview_data', false);
    },
    handleCommentCancelClick: function(){
        this.debugLog('handleCommentCancelClic', true);
        this.setState({workflowCommentPopup:undefined});
        this.debugLog('handleCommentCancelClic', false);
    },
    handleCommentSaveClick: function(comment){
        this.debugLog('handleCommentSaveClick', true);
        this.state.workflow_change_data.workflow_comment = comment;
        if (!comment || (comment.trim() == "")) {
            Notify(R.message_enter_workflow_comment, 'bottom-right', notify_timeout, 'red', 'fa-check', true);
        }
        else {
            this.setState({workflowCommentPopup:undefined});
            this.handle_workflow_change();
        }
        this.debugLog('handleCommentSaveClick', false);
    },
    save_scroll_position: function(){
        this.debugLog('save_scroll_position', true);
        this.scrollPosition = $(window).scrollTop();
        this.debugLog('save_scroll_position', false);
    },
    restore_scroll_position: function () {
        this.debugLog('restore_scroll_position', true);
        $(window).scrollTop(this.scrollPosition);
        this.debugLog('restore_scroll_position', false);
    },
    on_calendar_item_click: function(data){
        data.cancel = true;
        if (data.appointmentData){
            data = data.appointmentData;
        }
        var data_row = data.record, context = this;
        if (data_row && data_row._id) {
            var app_object = {};
            app_object.code = context.state.app_object.edit_app_object;
            app_object.data_row = data_row;
            app_object._id = data_row._id;
            if(context.props.grid_is_on_edit_form) {
                var ref_data = context.props.nested_reference_entity_data;
                context.props.parent_react_entity.setState({
                    nested_reference_entity_data: ref_data,
                    reference_entity_id: data_row._id,
                    grid_is_on_edit_form: true
                });
            }
            else {
                context.setState({editForm: app_object});
            }
        }
    },
    init_calendar_datasource: function(){
        this.debugLog('init_calendar_datasource', true);
        this.calendar_data_source = this.load_calendar_dataSource();
        this.debugLog('init_calendar_datasource', false);
    },
    render: function () {
        this.debugLog('render', true);
        var context = this;
        var app_object_name = this.state.app_object ? this.state.app_object.name : "";
        var error_component = "";
        if (this.state.error) {
            error_component =
                <div><ErrorNotificationComponent message={this.state.error} on_close={this.on_error_close}/><br />
                </div>;
        }
        var export_component = "";
        var displayCloseButton='none';
        if (!this.props.skip_init) {
            displayCloseButton='';
            export_component = (<div id={"hidden_export_" + this.state.grid_id}>&nbsp;</div>);
        }
        var borderColor = ((this.props.parent_react_entity) ? "lightgray" : "palegreen");
        var workflow_status_html;
        if (this.state.app_object && this.state.app_object.workflow_states) {
            if (this.props.conditions && this.props.conditions.workflow_status) {
                var workflow_status = this.state.app_object.workflow_states[this.props.conditions.workflow_status];
                if ((workflow_status && workflow_status.caption && (workflow_status.caption.trim() != ""))) {
                    if (workflow_status && workflow_status.view_options && workflow_status.view_options.class_color) {
                        borderColor = workflow_status.view_options.class_color;
                    }
                    workflow_status_html = (<span>{" "}<span className={"label label-"+borderColor}>{" " + workflow_status.caption.toUpperCase() + " "}</span> </span>);
                }
            }
        }
        var editElement = null;
        if (this.state.editForm) {
            editElement = <EditFormComponent new_entity_json={this.props.new_entity_json}
                                             app_object_code={this.state.editForm.code}
                                             data={undefined}
                                             return_app_object_code = {this.state.app_object.code}
                                             handle_executing={this.props.handle_executing}
                                             isModal = {true}
                                             navigation_handler={this.navigation_handler}
                                             _id={this.state.editForm._id}
                                             key={this.state.editForm.code + this.state.editForm._id}
                                             app_object_handler={this.props.app_object_handler}
                                             update_avatar={this.get_user_avatar}
                                             ref="editForm"
                                             update_user_info={this.get_user_info}
                                             is_nested_grid_child={this.props.skip_init || this.props.grid_is_on_edit_form}
                                             duplicate_id = {this.state.duplicate_id}
            />;
        }
        var workflow_comment_popup = null;
        if (this.state.workflowCommentPopup) {
            workflow_comment_popup = <EditFormComment
                title={this.state.workflowCommentPopup.title}
                handleSaveClick={this.handleCommentSaveClick}
                handleCancelClick={this.handleCommentCancelClick}
                comment={this.state.workflow_comment}
                style={{padding : '10px'}}
            />;
            workflow_comment_popup = <ModalComponent handleHideModal={this.handle_close} ref="modal">
                {workflow_comment_popup}
            </ModalComponent>;
        }
        var datalist_description = "",
            showBodyDatagrid="block",
            displayDescription,
            numOfRegisters="",
            marginRightskip="5px",
            colorSkip='rgba(96,96,96,1)',
            close_button;
        if(this.props.skip_init || this.props.grid_is_on_edit_form){
            if(this.props.skip_init) {
                numOfRegisters = " (" + this.state.entity_instances.length + ")";
                if ($.trim(numOfRegisters) == '(0)') {
                    numOfRegisters = '';
                }
            }
            else if (this.state.record_count) {
                var elementX = $("i[id='_toggle'][data-unique-id='" + this.state.grid_id + "']").attr("class");
                if (elementX && elementX.indexOf("plus") != -1) {
                    numOfRegisters = " (" + this.state.record_count + ")";
                    if ($.trim(numOfRegisters) == '(0)') {
                        numOfRegisters = '';
                    }
                }
            }
            displayDescription = (this.state.is_open || this.is_desc_button_toggling)?"inline-block":'none';
            showBodyDatagrid = (this.state.is_open || this.is_grid_toggling)?"block":"none";
            marginRightskip="10px";
        }
        var descriptionButton=   <i  style={{
                                        cursor : "pointer" ,
                                        color : colorSkip,
                                        display : displayDescription,
                                        fontSize : "14px",
                                        marginRight:marginRightskip
                                    }}
                                     data-unique-id={this.state.grid_id}
                                     onClick={ this.openDescriptionGrid.bind(this,this.state.grid_id)  }
                                     className="fa fa-question fa-3 clickable" aria-hidden="true" is-nested="true">&nbsp;</i>;
        if (this.state.app_object && this.state.app_object.custom_properties.view_modes && this.state.app_object.custom_properties.view_modes.length > 1 && this.state.app_object.custom_properties.view_modes) {
            var view_buttons=[];
            var view_modes = this.state.app_object.custom_properties.view_modes;
            var iconcolor = "#000";
            for(var i = 0; i < view_modes.length; i++) {
                var iconsfa = "";
                switch(view_modes[i]) {
                    case "tree_view":
                        iconsfa = "fa-list-ul";
                        break;
                    case "data_list":
                        iconsfa = "fa-table";
                        break;
                    case "calendar_view":
                        iconsfa = "fa-calendar-o";
                        break;
                    case "map_view":
                        iconsfa = "fa-map-marker";
                        break;
                    default:
                }
                if(view_modes[i] == this.state.selectedViewsetting) {
                    iconcolor = "rgb(93, 178, 255)";
                }
                else{
                    iconcolor = "#000";
                }
                var new_buttons =<i  style={{
                    cursor : "pointer" ,
                    color : iconcolor,
                    display : displayDescription,
                    marginRight: marginRightskip,
                    fontSize : "14px"
                }}
                                     key={view_modes[i]+"id"}
                                     onClick={ this.change_view_state.bind(this,view_modes[i])}
                                     className={"fa "+ iconsfa} aria-hidden="true" is-nested="true">&nbsp;</i>;
                view_buttons.push(new_buttons);
            }
        }
        if(!this.props.grid_is_on_edit_form && !this.props.skip_location_push) {
            close_button = <i id="close-button" style={{
                                    cursor : "pointer",
                                    color : colorSkip,
                                    display : displayCloseButton,
                                    fontSize : "14.7px",
                                    marginRight:"10px"
                                }}
                              onClick={this.handle_close}
                              className="fa fa-times clickable" aria-hidden="true" is-nested="true">&nbsp;</i>;
        }
        if((this.state.app_object && this.state.app_object.description) || (this.state.entity_attributes && this.state.entity_attributes.description_plural)){
            var app_object_description;
            if(this.state.app_object && this.state.app_object.description){
                app_object_description = this.state.app_object.description;
            }
            else {
                app_object_description = this.state.entity_attributes.description_plural;
            }
            var  stylecontainer= {
                "wordBreak" : "break-word",
                "borderStyle": "solid",
                "borderWidth": "2px",
                "borderRadius": "5px",
                "marginBottom": "10px",
                "position":"relative"
            };
            var styleback = {
                "backgroundColor" : borderColor,
                "width": "100%",
                "opacity":"0.3",
                "height":"100%",
                "position":"absolute"
            };
            var styletext = {
                "padding": "10px",
                "color":"black"
            };
            datalist_description = (<div id="datalist_description"  className={"bordered-bottom bordered-"+borderColor} style={stylecontainer} >
                <div  style={styleback}>
                </div>
                <div style={styletext}>
                    <i style={{"marginRight":"5px","fontSize":"15px"}} className="fa fa-check-square-o">&nbsp;</i>
                    {app_object_description}
                </div>
            </div>);
        }
        var assign_to_element = '';
        if (this.state &&
            this.state.app_object &&
            this.state.app_object.custom_properties &&
            this.state.app_object.custom_properties.assign_to &&
            this.state.selectedViewsetting == 'data_list' &&
            !this.props.skip_init && !this.props.grid_is_on_edit_form) {
            assign_to_element = this.build_assign_box();
        }
        var choose_report_template ="";
        if(context.state.report_options){
            var options_report = [],
                reports = context.state.report_options;
            for (var j = 0; j < reports.length; j++) {
                var lov = reports[j],
                    option_report = <option key={lov.report_code} data-html="true" value={lov.report_code}>
                        {lov.report_caption}
                    </option>;
                options_report.push(option_report);
            }
            choose_report_template = <div style={{"overflow":"inherit!important"}} className="col-xs-12 reportclass" key={"idchoose_report_popover"} id={"idchoose_report_popover"}>
                <div style={{"textAlign":"center","marginBottom":"10px"}}>
                    {R.choose_print_template?R.choose_print_template:'Select Reports to Print'}
                </div>
                <div data-html="true" className="reportcls form-group">
                    <select id="selectchoose_report_popover"
                            multiple="multiple"
                            className="form-control"
                            key="selectchoose_report_popover">
                        {options_report}
                    </select>
                </div>
            </div>;
        }
        var tree_view_data,
            tree_view = context.state.selectedViewsetting == "tree_view",
            addButton = '',
            popover_div = <div id="popover_div" style={{"position":"absolute","left":"-9999px","visibility":"hidden"}} >
                {choose_report_template}
            </div>,
            button_container = <div id="button-container"
                                    className="col-sm-12 widget-body"
                                    style={{ textAlign: "right",
                                        paddingRight :"5px" ,
                                        paddingTop : "5px",
                                        backgroundColor : "white",
                                        display : "none" }}
            >&nbsp;
            </div>,
            popup_element = <div ref={function(ref){context.popupElement = ref}}>
                <div ref={function(ref){context.popupContentElement = ref}}>
                    <div id={this.state.scrollViewContentElementId}>&nbsp;</div>
                </div>
            </div>,
            description_grid = <section style={(this.state.app_object && this.state.app_object.custom_properties && this.state.app_object.custom_properties.autoexpand_description) ? { display : "block" } : { display : "none" }}
                                        className={"description_grid"}
                                        data-unique-id={this.state.grid_id}
            >
                {datalist_description}
            </section>,
            treeviewV = "",
            datagridV = "",
            calendarviewV = "",
            mapviewV = "",
            view = (context.state.selectedViewsetting)?context.state.selectedViewsetting:'data_list';
        switch(view){
            case 'tree_view':
                tree_view_data = context.state.treeview_datasource;
                popover_div = '';
                popup_element = '';
                numOfRegisters = '';
                button_container = '';
                workflow_status_html = '';
                addButton = <button
                    style={{ "marginTop" : "1px" }}
                    type="button"
                    id={"tree_view_add"}
                    onClick={
                        function (e) {
                            var app_object = {};
                            app_object.code = context.state.app_object.edit_app_object;
                            if(context.props.grid_is_on_edit_form) {
                                var ref_data = context.props.nested_reference_entity_data;
                                context.props.parent_react_entity.setState({
                                    nested_reference_entity_data: ref_data,
                                    grid_is_on_edit_form: true
                                });
                            }
                            else {
                                context.setState({editForm: app_object});
                            }
                        }
                    }
                    className=" add-button dx-button"
                    tabIndex={-1}>
                    <div className='dx-button-content'>
                        <i style={{paddingLeft: "2px"}}
                           className='dx-icon dx-icon-add'>&nbsp;</i>
                    </div>
                </button>;
                var tree_view_component = <div key={"tree_view_key"}>
                    <EditorDevExtremeTreeView
                        dataSource={tree_view_data}
                        value={tree_view_data}
                        onItemClick={context.treeViewClick}
                        readOnly={""}
                    />
                </div>;
                treeviewV = <div className="widget-body"
                                 style={{  display :showBodyDatagrid, overflow:'hidden'  }}
                                 data-unique-id={this.state.grid_id}>
                    {description_grid}
                    {error_component}
                    <div style={{  textAlign :"right"}}>
                        {addButton}
                    </div>
                    {tree_view_component}
                </div>;
                break;
            case 'map_view':
                tree_view_data = context.state.mapview_datasource;
                popover_div = '';
                popup_element = '';
                numOfRegisters = '';
                button_container = '';
                workflow_status_html = '';
                var map_view_component = <div key={"map_view_key"}>
                    <EditorDevExtremeMapView
                        onItemClick={context.mapViewClick}
                        markers = {context.state.map_markers}
                        grid_id={this.state.grid_id}
                        getHeight={this.update_height}
                        readOnly={""}
                    />
                </div>;
                mapviewV = <div className="widget-body"
                                style={{  display :showBodyDatagrid, overflow:'hidden'  }}
                                data-unique-id={this.state.grid_id}>
                    {description_grid}
                    {error_component}
                    {map_view_component}
                </div>;
                break;
            case 'calendar_view':
                if (!this.calendar_data_source){
                    this.init_calendar_datasource();
                }
                else{
                    var calendar_view_component = <div key={"tree_view_key"}>
                        <EditorDevExtremeCalendarView
                            dataSource={this.calendar_data_source}
                            resources={this.state.resources}
                            attributes={this.state.entity_attributes}
                            onAppointmentClick={this.on_calendar_item_click}
                            getHeight={this.update_height}
                            grid_id={this.state.grid_id}
                            initDataSource={this.init_calendar_datasource}
                            readOnly={""}
                            buildResources={this.rebuild_resources}
                        />
                    </div>;
                }
                calendarviewV = <div className="widget-body"
                                     style={{  display :showBodyDatagrid, overflow:'hidden'  }}
                                     data-unique-id={this.state.grid_id}
                >
                    {description_grid}
                    {error_component}
                    {assign_to_element}
                    {calendar_view_component}
                    {export_component}
                </div>;
                break;
            default:
                datagridV = <div className="widget-body"
                                 style={{  display :showBodyDatagrid, overflow:'hidden'  }}
                                 data-unique-id={this.state.grid_id}
                >
                    {description_grid}
                    {error_component}
                    {assign_to_element}
                    <div id={this.state.grid_id}>&nbsp;</div>
                    {export_component}
                </div>;
        }
        var widget_caption;
        if(this.props.parent_react_entity) {
            widget_caption = (<span className="widget-caption clickable"
                                   onClick={ (!this.props.skip_init && !this.props.grid_is_on_edit_form) ?'':this.openBodyGrid.bind(this,this.state.grid_id) }
                                   style={{ cursor: "pointer"}}><span
                className="section_title_text">{app_object_name}{numOfRegisters}</span>
            </span>);
        }
        else {
            widget_caption = (<span className="widget-caption clickable"
                                   onClick={ (!this.props.skip_init && !this.props.grid_is_on_edit_form) ?'':this.openBodyGrid.bind(this,this.state.grid_id) }
                                   style={{ cursor: "pointer"}}>{app_object_name}{numOfRegisters}</span>);
        }
        var widget_buttons = <div className="widget-buttons">
                {view_buttons}
                {descriptionButton}
                <i data-type-element="headBtn"
                   id="_toggle"
                   data-count="0"
                   className={this.state.is_open?"fa fa-minus":"fa fa-plus" + " clickable"}
                   data-unique-id={this.state.grid_id}
                   style={{marginRight : "10px" ,
                       cursor : "pointer" ,
                       color  : "rgba(96,96,96,1)" ,
                       display : (this.props.skip_init || this.props.grid_is_on_edit_form) ? "" : "none"}}
                   onClick={ this.openBodyGrid.bind(this,this.state.grid_id) }
                   onKeyPress={function(gridID, event){if (event.key === "Enter") context.openBodyGrid(gridID);}.bind(this, this.state.grid_id)}
                   tabIndex="0"
                >
                    &nbsp;
                </i>
                {close_button}
            </div>;
        var widget_header = <div className={"widget-header bordered-bottom bordered-"+borderColor + ((this.props.parent_react_entity) ? " compact_header" : "")}>
                {widget_caption}
                {workflow_status_html}
                {widget_buttons}
            </div>;
        if( (view =='tree_view') && !tree_view_data){
            context.get_treeview_data();
            this.debugLog('render', false);
            return(<div></div>);
        }
        else {
            this.debugLog('render', false);
            return (<div id="datalist_cmp" className="widget">
                    {editElement}
                    {workflow_comment_popup}
                    {widget_header}
                    {workflow_comment_popup}
                    {popover_div}
                    {datagridV}
                    {treeviewV}
                    {mapviewV}
                    {calendarviewV}
                    {button_container}
                    {popup_element}
                </div>
            );
        }
    }
});